var $ = require('jQuery');
var Monitor = require('fe-monitor');
var hex_md5 = require('./../../lib/md5');
var template = require('../template/app.html');
/*require('./../style/app.less');*/
var Component = require('./Component');
var ChatWindow = require('./ChatWindow');
var ContactWindow = require('./ContactWindow');
var ImageViewer = require('./ImageViewer');
var AudioPlayer = require('./AudioPlayer');
var VideoPlayer = require('./VideoPlayer');
var ContactInfoWindow = require('./addon/contactInfoWindow/ContactInfoWindow');
var MultipleForwardWindow = require('./addon/MultipleForwardWindow/MultipleForwardWindow');
var FloatController = require('./addon/floats/FloatController');
var FloatView = require('./addon/floats/FloatView');
var myCollectWindow = require('./addon/myCollectWindow/myCollectWindow');
//var swComponent = require('./sw-component/sw-component');
//var Captcha = require('./Captcha');
var ContactStatus = require('./../constant/ContactStatus');
var AppStatus = require('./../constant/AppStatus');
var AppPosition = require('./../constant/AppPosition');
var dispatcher = require('./../global/dispatcher');
var dispatcherAccurate = require('./../global/dispatcherAccurate');
var stat = require('./../global/stat');
//var StatPoint = require('./../constant/StatPoint');
var ActionType = require('./../constant/ActionType');
var MsgStatus = require('./../constant/MsgStatus');
var WosInfo = require('./../constant/WosInfo');
var SupportedMsgs = require('./../constant/SupportedMsgs');
var session = require('./../store/session-new');
var Timer = require('./../../lib/Timer');
var asynstore = require('./../store/asyn');
var PageVisible = require('./../../lib/PageVisible');
var MainPage = require('./../../lib/MainPage');
var infoQuaCheck = require('./../../lib/infoQuaCheck');
var imageUploader = require('./../../lib/imageUploader');
var fileHandler = require('./../../lib/fileHandler');
var Base64 = require('./../../lib/base64bak').Base64;
var strToNumCompare = require('./../../lib/util').strToNumCompare;
var utils = require('./../global/utils');
var asynchPipe = utils.asynchPipe;
var isGroupUser = utils.isGroupUser;
var isEmpty = utils.isEmpty;
var jsonHandler = utils.jsonHandler;
var isShopModeUser = utils.isShopModeUser;
var isShopModeUserSource = utils.isShopModeUserSource;
var sumBigNumber = utils.sumBigNumber;
var isAnonymousSession = utils.isAnonymousSession;
var is_remind_helper = utils.is_remind_helper;
var MultipleContentMenu = require('./../constant/MultipleContentMenu');
var non_forward_show_types = MultipleContentMenu.non_forward_show_types;
var non_delete_show_types = MultipleContentMenu.non_delete_show_types;
var non_collect_show_types = MultipleContentMenu.non_collect_show_types;
var webimActiveKey = 'isWebimActive';
var config = require('./../global/config');
var gdic = require('./../global/globalDic');
var falseNewsDic = require('./../global/falseNewsDic');
var bindRtcEvents = require('./../extra/BindRtcEvents');
var groupTemplate = require('../template/organiz-add-group1.html');
var remarkTemplate = require('../template/chatwindow-header-plugin/remark-test.html');

var OrganizStructure = require('./session/OrganizStructure1');
var platform = require('../../lib/platform');
var Toast = require('./common/Toast');
var ModalWin = require('./common/ModalWindow');
var getMsgSize = require('../extra/CollectionHandler').getMsgSize;
var extendMsgValidity = require('../extra/CollectionHandler').extendMsgValidity;
const { urlConvert } = require('../../shop-mode-sdk/util/util');
// 绑定手机回调方法名
var bindcellphoneid = 1;
// 用户帖子信息
var _userTopic = {};
// 是否是首次Normal
/*var _isFirstNormal = true;*/
// 上传文件的审核结果
var fileHunterBack = {};    //key:wos_file_name value:{ret:0/其他  (0表示通过，其他不通过), isSent:true/false,msg:msg}
var _groupCurrentCount = {};   //key:user_id@user_source value:num
var _loadedGroupMsgsObj = {};
var _getAudioPlayer = function () {
  var audioplayer = this._children['audio-player'];
  if (!audioplayer) {
    audioplayer = new AudioPlayer();
    this._element.append(audioplayer.getElement());
    this._children['audio-player'] = audioplayer;
  }
  return audioplayer;
};
var _getVideoPlayer = function () {
  var videoplayer = this._children['video-player'];
  if (!videoplayer) {
    videoplayer = new VideoPlayer();
    this._element.append(videoplayer.getElement());
    this._children['video-player'] = videoplayer;
  }
  return videoplayer;
};
var _isMinWindow = function () {
  var isMin = false;
  var win = window.top;
  if (win.outerWidth != undefined) {
    isMin = win.outerWidth <= 160 && win.outerHeight <= 27;
  } else {
    isMin = win.screenTop < -30000 && win.screenLeft < -30000;
  }
  //console.log('********* isMin:'+isMin);
  return isMin;
};
var _handleNotify = function (mp, isMainPage) {
  var self = this;
  if (!isMainPage) {
    window.top.document.title = self._originalTitle;
    if (!!self._allunreadcountTimer) {
      self._allunreadcountTimer.stop();
    }
  } else {
    self._notify && self._notify.close();
    mp.set();
    if (self._allunreadcount > 0) {
      self.titleNotify(self._allunreadcount);
    }
  }
};
var _getMsgRecords = function (options, success, fail) {
  this._biz.getMsgRecords(options, function (msgs, otherLastShowedMsgId, min_msg_id) {
    success && success(msgs, otherLastShowedMsgId, min_msg_id);
  }, function (error) {
    fail(error);
  });
};
// 撤回消息查询
var _getReplaceMsgRecords = function (options, success, fail) {
  var me = this._biz.me();
  this._biz.getReplaceMsgRecords(options, function (msgs) {
    if (msgs.length == 0) {
      return success(msgs);
    }
    config['getUserinfo']([{
      user_id: options.user_id,
      user_source: options.user_source,
      shop_id: options.shop_id,
      shop_source: options.shop_source
    }, {
      user_id: me.user_id,
      user_source: me.user_source
    }], function (contacts) {
      $.each(msgs, function (index, msg) {
        msg.sender_info = contacts[msg.sender_id + '@' + msg.sender_source];
        msg.to_info = contacts[msg.to_id + '@' + msg.to_source];
      });
      success(msgs);
    });
  }, function (error) {
    fail(error);
  });
};
var _ackMsgRead = function (audioObj) {
  var self = this;
  var ackMsgArray = [];
  var ackMsgObj = {
    sender_id: audioObj.sender_id + '',
    sender_source: audioObj.sender_source,
    msg_id: audioObj.msg_id + '',
    to_id: audioObj.to_id + '',
    to_source: audioObj.to_source
  };
  ackMsgArray.push(ackMsgObj);
  self._biz.ackMsgRead(ackMsgArray, function () {
    // 修改消息为已播放
    dispatcher.dispatch({
      type: ActionType.MSG_AUDIO_ACK_READ,
      data: {
        msg_id: audioObj.msg_id
      }
    });
  })
};
var _isEmpty = function (input) {
  return input + '' === 'null' || input + '' === 'undefined' || input === '';
};
var _showISDCaptcha = function (data, callback) {
  var self = this;
  var level = data.param.level;
  var width = data.param.width;
  var sessionId = data.responseId;
  var captcha = ISDCaptcha({
    element: 'ISDCaptcha',//验证码组件需要绑定的元素ID
    width: width,//图片宽度,需管理后台设置,不能再页面自定义，
    type: level,//验证码类型; 从SCF服务register接口中组件参数返回
    showType: 'win',//展现形式;win:弹出，popup:触发,'':默认为嵌入
    sessionId: sessionId,//从SCF服务register接口中返回
    winAutoShow: true,//弹出式时添加此属性会自动弹出	,默认不自动弹出
    successCallback: function successCallback(data) {//验证码验证成功后的回调函数
      var params = {
        'sessionId': sessionId,
        'level': level,
        'successToken': data.successToken
      };
      self._biz.validateCaptcha(params, function (data) {
        callback(data);
      }, function () {
        callback(null);
      });
    },
    failCallback: function failCallback() {
      callback(null);
    }
  });
  captcha.init();//初始化组件
};
var _extendMsgValidityHandler = function (msg, opts) {
  return new Promise((resolve, reject) => {
    var self = this;
    var msgcontent = (msg._original_content) ? msg._original_content : msg.content;
    if (!isEmpty(msg) && msg.show_type == 'chat_card') {
      msgcontent = msg;
      msgcontent.type = 'chat_card';
    }
    if (['video', 'audio', 'file', 'msg_batch_forward_card', 'chat_card'].indexOf(msgcontent.type) == -1) {
      return resolve()
      //return success && success();
    }
    var no_extendMsgValidity = !isEmpty(opts) && !isEmpty(opts.no_extendMsgValidity) ? opts.no_extendMsgValidity : false;
    //对于转发消息，需要遍历里面的msgs
    if (msgcontent.type === 'msg_batch_forward_card') {
      // 是否包括嵌套转发
      var isHasForwardCard = msgcontent.msgs_preview && msgcontent.msgs_preview.filter(function (msgcontentMsg) {
        if (typeof msgcontentMsg.content == 'string') {
          msgcontentMsg.content = jsonHandler.parse(msgcontentMsg.content);
        }
        return msgcontentMsg.content.type == 'msg_batch_forward_card';
      })
      if (isHasForwardCard && isHasForwardCard.length > 0 && msgcontent.msgs && msgcontent.msgs.length) {
        // 删除收藏
        if (isEmpty(msg.sender_id) || isEmpty(msg.to_id)) {
          var vaildForwardMsgs = [];
          if (!isEmpty(msg.forward_msgs && msg.forward_msgs.length > 0)) {
            // 嵌套转发
            msg.forward_msgs.forEach(function (forward_message) {
              if (typeof forward_message.content == 'string') {
                forward_message.content = jsonHandler.parse(forward_message.content);
              }
              forward_message.forward_msg_id = msg.forward_msg_id ? msg.forward_msg_id : msg.msg_id;
              forward_message.sender_id = msg.sender_id;
              forward_message.sender_source = msg.sender_source;
              forward_message.to_id = msg.to_id;
              forward_message.to_source = msg.to_source;
              vaildForwardMsgs.push(_extendMsgValidityHandler.call(self, forward_message, opts));
            });
          } else {
            // 嵌套转发最里层
            msg.content && msg.content.msgs_preview && msg.content.msgs_preview.forEach(function (forward_message) {
              if (forward_message.type != 'msg_batch_forward_card') {
                vaildForwardMsgs.push(_extendMsgValidityHandler.call(self, forward_message, opts));
              }
            })
          }
          Promise.all(vaildForwardMsgs).then((res) => {
            resolve(res)
          }).catch((err) => {
            reject(err)
          })
          return;
        }
        var msg_ids = [];
        msgcontent.msgs.forEach(function (msgcontentMsg) {
          msg_ids.push(msgcontentMsg.msg_id);
        });
        self._biz.getForwardMsg({
          forward_msg_id: msg.forward_msg_id ? msg.forward_msg_id : msg.msg_id,
          forward_sender_id: msg.sender_id,
          forward_sender_source: msg.sender_source,
          forward_to_id: msg.to_id,
          forward_to_source: msg.to_source,
          msgs: msg_ids
        }, function (forward_messages) {
          var forwardMsgs = forward_messages;
          var vaildForwardMsgs = [];
          forward_messages.forEach(function (forward_message) {
            if (typeof forward_message.content == 'string') {
              forward_message.content = jsonHandler.parse(forward_message.content);
            }
            forward_message.forward_msg_id = msg.forward_msg_id ? msg.forward_msg_id : msg.msg_id;
            forward_message.sender_id = msg.sender_id;
            forward_message.sender_source = msg.sender_source;
            forward_message.to_id = msg.to_id;
            forward_message.to_source = msg.to_source;
            vaildForwardMsgs.push(_extendMsgValidityHandler.call(self, forward_message, opts));
          });
          Promise.all(vaildForwardMsgs).then((res) => {
            resolve(res)
          }).catch((err) => {
            reject(err)
          })
        }, function (err) {
          reject(err)
        });
      } else if (msgcontent.msgs_preview && msgcontent.msgs_preview.length) {
        var vaildForwardMsgs = [];
        msgcontent.msgs_preview.forEach(function (msgcontentMsg) {
          if (typeof msgcontentMsg.content == 'string') {
            msgcontentMsg.content = jsonHandler.parse(msgcontentMsg.content);
          }
          vaildForwardMsgs.push(_extendMsgValidityHandler.call(self, msgcontentMsg, opts));
        });
        Promise.all(vaildForwardMsgs).then((res) => {
          resolve(res)
        }).catch((err) => {
          reject(err)
        })
      }
    } else if (msgcontent.type === 'chat_card') {
      var needExtendVaildArr = [];
      msgcontent.msgs.forEach(function (msgcontentMsg) {
        if (typeof msgcontentMsg.content == 'string') {
          msgcontentMsg.content = jsonHandler.parse(msgcontentMsg.content);
        }
        needExtendVaildArr.push(_extendMsgValidityHandler.call(self, msgcontentMsg, opts));
      });
      Promise.all(needExtendVaildArr).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    } else {
      var me = self._biz.me();
      var urlArr = [];
      var splitString = msgcontent.url.indexOf(WosInfo.WOS_CLIENT_APP_ID) != -1 && WosInfo.WOS_CLIENT_URL ? WosInfo.WOS_CLIENT_URL : WosInfo.WOS_CDN_URL ? WosInfo.WOS_CDN_URL : '';
      var splitArr = decodeURIComponent(msgcontent.url).split(splitString);
      var urlArr = !isEmpty(splitString) && splitArr.length > 1 ? splitArr[1].split('/') : !isEmpty(splitString) && splitArr.length > 0 ? splitArr[0].split('/') : [];
      var wos_file_name = msgcontent.wos_file_name ? msgcontent.wos_file_name : msgcontent.url.indexOf(WosInfo.WOS_CLIENT_APP_ID) != -1 ? urlArr[8] || urlArr[5] : urlArr[3];
      var urlLen = urlArr.length;
      var WOS_APP_ID = msgcontent.url.indexOf(WosInfo.WOS_CLIENT_APP_ID) != -1 ? WosInfo.WOS_CLIENT_APP_ID : urlArr[1];
      if (isEmpty(WOS_APP_ID) && urlLen > 3) {
        WOS_APP_ID = urlArr[urlLen - 3];
      }
      var wos_params = {
        wos_appid: WOS_APP_ID,
        wos_file_name: wos_file_name,
        send_type: msgcontent.type,
        sender_id:  me.user_id,
        sender_source: me.user_source,
        to_id: me.user_id === msg.to_id ? msg.sender_id : msg.to_id,
        to_source: msg.to_source
      };
      if (isEmpty(WOS_APP_ID)) {
        reject(new Error("参数错误"));
        return;
      }

      var wosArr = []
      wosArr.push(_getWosToken.call(self, wos_params))

      // 封面也需要延长有效期
      if (msgcontent.type === 'video') {
        var thumbString = msgcontent.thumbnail_url.indexOf(WosInfo.WOS_CLIENT_APP_ID) != -1 && WosInfo.WOS_CLIENT_URL ? WosInfo.WOS_CLIENT_URL : WosInfo.WOS_CDN_URL ? WosInfo.WOS_CDN_URL : '';
        if (msgcontent.thumbnail_url.indexOf(thumbString) === 0) {
          var thumbArr = decodeURIComponent(msgcontent.thumbnail_url).split(thumbString);
          var thumbUrlArr = !isEmpty(thumbString) && thumbArr.length > 1 ? thumbArr[1].split('/') : !isEmpty(thumbString) && thumbArr.length > 0 ? thumbArr[0].split('/') : [];
          console.log(thumbUrlArr, 'thumbUrlArr')
          var thunbwos_file_name = thumbUrlArr[8] || thumbUrlArr[5] || thumbUrlArr[3];
          var urlLen = thumbUrlArr.length;
  
          var thumb_wos_params = {
            wos_appid: WOS_APP_ID,
            wos_file_name: thunbwos_file_name,
            send_type: 'file',
            sender_id:  me.user_id,
            sender_source: me.user_source,
            to_id: me.user_id === msg.to_id ? msg.sender_id : msg.to_id,
            to_source: msg.to_source
          };
          console.log(thumb_wos_params, 'thumb_wos_params')
          wosArr.push(_getWosToken.call(self, thumb_wos_params).then((data)=>{
            return Promise.resolve({
              ...data,
              thumb_msg: {
                content: {
                  url: msgcontent.thumbnail_url,
                  type: 'file'
                }
              }
            })
          }))
        }
      }
      Promise.all(wosArr).then(data => {
        var validArr = []
        data.forEach((item, index) => {
          // get_wostoken 返回的单位是秒，wos上传服务器接口支持的单位是小时，需要做一个转换
          item && item.wos_file_expire && (item.wos_file_expire = Math.floor(+item.wos_file_expire / 3600));
          item._wos_file_expire = item.wos_file_expire;
          item.no_extendMsgValidity = no_extendMsgValidity;
          if (no_extendMsgValidity) {
            // 仅检查， 不延长文件有效期
            if (data) {
              item.no_extendMsgValidity = true;
            } else {
              reject(err);
              return;
            }
          } else if (!isEmpty(opts) && !no_extendMsgValidity && !isEmpty(opts.wos_file_expire)) {
            item.extend_wos_file_expire = opts.wos_file_expire;
          }

          if (isEmpty(item.thumb_msg)) {
            validArr.push(extendMsgValidity(WosInfo, item, msg))
          } else {
            console.log(item, '封面---')
            validArr.push(extendMsgValidity(WosInfo, item, item.thumb_msg))
          }
        })
        Promise.all(validArr).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      }).catch(err => {
        reject(err)
      })
    }
  })
}

var _getWosToken = function(params) {
  return new Promise(resolve => {
    var self = this;
    return self._biz.getWosToken(params, (data) => {
      resolve(data)
    })
  })
}

var _getMsgSize = function (msg) {
  return new Promise((resolve, reject) => {
    var self = this;
    var msgcontent = msg._original_content ? msg._original_content : msg.content;
    if (msgcontent.type == 'msg_batch_forward_card') {
      // 是否包括嵌套转发
      var isHasForwardCard = msgcontent.msgs_preview && msgcontent.msgs_preview.filter(function (msgcontentMsg) {
        if (typeof msgcontentMsg.content == 'string') {
          msgcontentMsg.content = jsonHandler.parse(msgcontentMsg.content);
        }
        return msgcontentMsg.content.type == 'msg_batch_forward_card';
      })
      if (isHasForwardCard && isHasForwardCard.length > 0 && msgcontent.msgs && msgcontent.msgs.length) {
        var msg_ids = [];
        msgcontent.msgs.forEach(function (msgcontentMsg) {
          msg_ids.push(msgcontentMsg.msg_id);
        });
        self._biz.getForwardMsg({
          forward_msg_id: msg.forward_msg_id ? msg.forward_msg_id : msg.msg_id,
          forward_sender_id: msg.sender_id,
          forward_sender_source: msg.sender_source,
          forward_to_id: msg.to_id,
          forward_to_source: msg.to_source,
          msgs: msg_ids
        }, function (forward_messages) {
          var forwardMsgs = forward_messages;
          var sizeForwardMsgs = [];
          var sizeForward = 0;
          forward_messages.forEach(function (forward_message) {
            if (typeof forward_message.content == 'string') {
              forward_message.content = jsonHandler.parse(forward_message.content);
            }
            forward_message.forward_msg_id = msg.forward_msg_id ? msg.forward_msg_id : msg.msg_id;
            forward_message.sender_id = msg.sender_id;
            forward_message.sender_source = msg.sender_source;
            forward_message.to_id = msg.to_id;
            forward_message.to_source = msg.to_source;
            sizeForwardMsgs.push(_getMsgSize.call(self, forward_message));
          });
          Promise.all(sizeForwardMsgs).then((sizes) => {
            sizes.forEach(size => {
              sizeForward += Number(size)
            });
            resolve(sizeForward)
          }).catch((err) => {
            reject(err)
          })
        }, function (err) {
          reject(err)
        });
      } else if (msgcontent.msgs_preview && msgcontent.msgs_preview.length) {
        var sizeForwardMsgs = [];
        var sizeForward = 0;
        msgcontent.msgs_preview.forEach(function (msgcontentMsg) {
          if (typeof msgcontentMsg.content == 'string') {
            msgcontentMsg.content = jsonHandler.parse(msgcontentMsg.content);
          }
          sizeForwardMsgs.push(_getMsgSize.call(self, msgcontentMsg));
        });
        Promise.all(sizeForwardMsgs).then((sizes) => {
          sizes.forEach(size => {
            sizeForward += Number(size)
          });
          resolve(sizeForward)
        }).catch((err) => {
          reject(err)
        })
      }
    } else {
      getMsgSize(msg).then((res) => {
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    }
  })
}

var App = function (options) {
  // 默认：关闭状态:
  this._status = AppStatus.MIN;
  // 位置
  this._position;
  // 当前聊天的人
  this._currentcontact = null;
  // 业务逻辑service
  this._biz = null;
  //原始title名称
  this._originalTitle;

  (function (self) {
    var defaults = {
      template: template,
      config: {
        //参考global/config下配置文件
      },
      biz: null
    };
    $.extend(defaults, options);
    Component.call(self, defaults);

    $('body').append($(remarkTemplate));


    //外部配置文件合并
    config['me'] = function () {
      return self._biz ? self._biz.me() : null;
    };
    config['getUserinfo'] = function () {
      self._biz.getContact.apply(self._biz, arguments);
    };
    $.extend(true, config, options.config);
    self._init(defaults.biz, defaults.shop_biz);
    var envs = self._biz.options.envs ? self._biz.options.envs : 'online';
    WosInfo = WosInfo[envs];
  })(this);

  (function (self) {
    self._children['contact-window'] = new ContactWindow({
      me: self._biz.me(),
      getMoreSession: function (cb) {
        if (self._biz.isLogined()) {
          self._biz.getSessions({ count: 50 }, function (sessions, have_more) {
            cb(sessions, have_more);
          }, function () {
            cb([], true);
          });
        } else {
          var _this = this;
          setTimeout(function () {
            _this.getMoreSession(cb);
          }, 100);
        }
      }
    });
    self._element.append(self._children['contact-window'].getElement());

    // self._children['sw-component'] = new swComponent({
    //   is_vm: true
    // });

    // self._element.append(self._children['sw-component'].getElement());

    // self._children['sw-component'].setData({
    //   lmj : {
    //     mate: 'likd-b',
    //     gender: 'female-m',
    //     name: 'lmj-b',
    //     note: {
    //       date: '2021'
    //     }
    //   },
    //   users: [
    //     {
    //         name: '2',
    //         key: '2'
    //     },
    //     {
    //         name: '3',
    //         key: '3'
    //     },
    //     {
    //         name: '4',
    //         key: '4'
    //     }
    //   ],
    //   html: '<a class="im-a"></a>',
    //   img_src: '//pic1.58cdn.com.cn/nowater/p1/n_v1bj3gzr2amtfvrddjtrka.png',
    //   is_show: false,
    //   show: false,
    //   hide: true
    // });

    self._children['contact-window'].addEventListener('imMinimize', function () {
      switch (self._status) {
        case AppStatus.MIN:
          self.normalize();
          break;
        case AppStatus.NORMAL:
          self.minimize();
          break;
        default:
          break;
      }
    });

    self._children['contact-info-window'] = new ContactInfoWindow({

    });
    self._element.append(self._children['contact-info-window'].getElement());
    self._children['float-controller'] = new FloatController({});
    self._children['float-controller'].bound(self._element.find('.im-float-container'));

    //监听评价卡片的提交
    // self._children['chat-window'].addEventListener('evaluateCompleted',(value)=>{
    //   console.log("44444444",value);
    //   self.triggerEvent('evaluateCompleted', value);
    // });
  })(this);

  // 事件监听，发送消息
  (function (self) {
    var _temp_msg_id = 0;   // 临时消息id
    var _temp_msgs = {};    // key:temp_msg_id, value:msg
    var me = self._biz.me();
    var getWosUrl = function (wosData) {
      if (wosData && typeof wosData === 'string') {
        wosData = jsonHandler.parse(wosData).data;
      }
      return wosData && wosData.access_url ? wosData.access_url : wosData.url ? wosData.url : '';
    };
    var sendMsg = function (message, success, fail) {
      var type = self._position == AppPosition.CENTER ? 'center_session_click' : 'normal_session_click';
      // 输入中通道测试
      if (message.content && message.content.type == 'text' && message.content.msg == 'BEINPUTTING') {
        var opts = {
          target_id: message.to_id,
          target_source: message.to_source,
          offline: '1',
          event_type: 'BEINPUTTING',
          event_info: '测试'
        }
        self._biz.updateEvent(opts, function () {
          console.log('触发输入中...');
        })
      }
      self._biz.sendMsg({
        msg: message,
        onSendMsgBegin: function () {
          message.status = MsgStatus.SENDING;
          dispatcher.dispatch({
            type: ActionType.MSG_SEND_STATUS_CHANGE,
            data: message
          });
        },
        onSendMsgSuccess: function (result) {
          delete _temp_msgs[message.temp_msg_id];
          message.msg_id = result.msg_id;
          message.status = MsgStatus.SUCCESS;
          dispatcher.dispatch({
            type: ActionType.MSG_SEND_STATUS_CHANGE,
            data: message
          });
          success && success();
        },
        onSendMsgFail: function (error) {
          message.status = MsgStatus.FAIL;
          message.feedback_msg_hide = error.msg_hide;
          message.feedback = error.error_msg ? error.error_msg : '';
          if (error === '') {
            message.feedback = '您的网络未连接，请检查后重试。';
          }
          else if (error.error_code == 42009) {
            //绑定失败后再次点击绑定，执行方法
            var id = 'bindcellphone_' + bindcellphoneid++;
            window[id] = function () {
              config['bind-cellphone'](function () {
                send(message);
              }, function () {
                var url = config['get-bindcellphone-url']();
                if (!url) {
                  url = 'javascript:void(0)';
                }
                // 对于绑定手机号，自定义失败文案
                message.feedback_msg_hide = '';
                message.feedback = '发送失败，请<a href="' + url + '" target="_blank" style="color:#528cd8;text-decoration:none;" onclick="' + id + '()">绑定</a>手机号后重试。';
                dispatcher.dispatch({
                  type: ActionType.MSG_SEND_STATUS_CHANGE,
                  data: message
                });
              });
            };
            return window[id]();
          }
          else if (error.error_code == 40021) {
            //埋点统计（验证码出现）
            //stat.report(StatPoint.captcha_appear);
            if (window.WMDA_REPORT) {
              window.WMDA_REPORT('custom', { event_id: '1' })
            }
            var showCaptcha = function () {
              var captcha_cb, captcha_width = 310;
              // 获取验证码信息
              self._biz.getCaptcha({
                normal_get: 1,
                captcha_ver: 'v3',
                captcha_width: captcha_width
              }, function (data) {
                if (!_isEmpty(data.param) && !_isEmpty(data.param.level) && !_isEmpty(data.param.width)) {
                  captcha_cb = function (data) {
                    if (!_isEmpty(data) && data + '' === '0') {
                      send(message);
                    } else {
                      showCaptcha();
                    }
                  };
                }
                _showISDCaptcha.call(self, data, captcha_cb);
              }, function () {
                showCaptcha()
              });
            };

            showCaptcha();
          } else if (error.error_code == 42051) {
            message.feedback = '发送失败';
            if (window.WMDA_REPORT) {
              //window.WMDA_REPORT('custom', { event_id: '1' })
            }
          }
          dispatcher.dispatch({
            type: ActionType.MSG_SEND_STATUS_CHANGE,
            data: message
          });
          fail && fail();
        }
      });
    };
    var notifyHunter = function (options, success, error) {
      self._biz.notifyHunter(options, success, error)
    };
    var checkFile = function (message, success, error) {
      var fileContent = message.content;
      var fileUrl = fileContent.url;
      var checkFileParams = {
        wos_file_name: fileContent.wos_file_name,
        to_source: message.to_source,
        url: fileUrl
      };
      self._biz.checkFile(checkFileParams, success, error)
    };
    var uploadFile = function (options) {
      var file = options.file;
      var message = options.message;
      var msgType = message.content.type;
      var name = file.name || '';
      var suffix = (name.match(/(\.[\w]+$)/) || {})[1] || '';
      var getInitInfo = function (opts, cb) {
        var wos_params = {
          wos_appid: WosInfo.WOS_APP_ID,
          wos_file_name: '',
          suffix: opts && opts.suffix ? opts.suffix : suffix,
          send_type: opts && opts.send_type ? opts.send_type : message.content.type,
          sender_id: message.shop_id ? message.shop_id : message.sender_id ? message.sender_id : me.user_id,
          sender_source: message.shop_source ? message.shop_source : message.sender_source ? message.sender_source : me.user_source,
          to_id: message.to_id,
          to_source: message.to_source
        };
        self._biz.getWosToken(wos_params, function (data) {
          // get_wostoken 返回的单位是秒，wos上传服务器接口支持的单位是小时，需要做一个转换
          data && data.wos_file_expire && (data.wos_file_expire = Math.floor(+data.wos_file_expire / 3600));

          cb(data);
        }, function (err) {
          cb(null);
        });
      };
      var doVideoImgUpload = function (file, cb) {
        fileHandler.createThumbnail(file, function (thumbnailObj) {
          $.extend(true, message.content, {
            thumbnail_url: thumbnailObj.data,
            thumbnail_width: thumbnailObj.width,
            thumbnail_height: thumbnailObj.height,
            duration: thumbnailObj.duration
          });
          var convertBase64UrlToBlob = function (urlData) {
            var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte

            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
              ia[i] = bytes.charCodeAt(i);
            }

            return new Blob([ab], { type: 'image/jpg' });
          };
          getInitInfo({
            send_type: 'file',
            suffix: '.jpg'
          }, function (data) {
            data.file = convertBase64UrlToBlob(thumbnailObj.data);
            // imageUploader.init();
            // imageUploader.upload(thumbnailObj.data, function (url) {
            //   $.extend(true, message.content, {
            //     thumbnail_url: url
            //   });
            fileHandler.upload(data, function (wosData) {
              $.extend(true, message.content, {
                thumbnail_url: getWosUrl(wosData)
              });
              message.status = MsgStatus.UPLOADING;
              // 首帧图修改为图片格式，不再存在兼容性
              // var fitSarari = platform.name.indexOf('Safari') !== -1;
              // if (fitSarari) {
              //   var _message = $.extend(true, {}, message);
              //   _message.content.thumbnail_url = thumbnailObj.data;
              //   dispatcher.dispatch({
              //     type: ActionType.MSG_INFO_UPDATED,
              //     data: _message
              //   });
              // } else {
              //   dispatcher.dispatch({
              //     type: ActionType.MSG_INFO_UPDATED,
              //     data: message
              //   });
              // }
              dispatcher.dispatch({
                type: ActionType.MSG_INFO_UPDATED,
                data: message
              });
              cb();
            }, function () {
              cb();
            }, null);
          });
        });
      };
      var doUpLoadFile = function (data) {
        var wos_file_name = data.wos_file_name ? data.wos_file_name : '';
        var successCb = function (result) {
          var file_url = getWosUrl(result);
          var baseExtendContent = {
            url: file_url,
            wos_file_name: wos_file_name,
            size: file.size,
            format: file.type,
            extra: ''
          };
          if (msgType === 'file') {
            $.extend(true, baseExtendContent, {
              original_file_name: file.name
            });
          }
          $.extend(true, message.content, baseExtendContent);
          // 信质验证文件
          var hunterOptions = {
            wos_file_name: wos_file_name,
            url: file_url,
            type: message.content.type,
            file_format: file.type,
            file_size: file.size,
            sender_id: message.shop_id ? message.shop_id : message.sender_id ? message.sender_id : me.user_id,
            sender_source: message.shop_source ? message.shop_source : message.sender_source ? message.sender_source : me.user_source,
            to_id: message.to_id,
            to_source: message.to_source
          };
          message.content.file_sender_id = hunterOptions.sender_id;
          message.content.file_sender_source = hunterOptions.sender_source;
          notifyHunter(hunterOptions, function () {
            // 判断消息是否已经取消发送
            if (message.status != MsgStatus.CANCEL_SENDING) {
              sendMsg(message);
            }
          }, function (error) {
            options.onHunterCheckFail({
              error: error,
              wos_file_name: wos_file_name
            });
          });
          options.onUploadSuccess(message);
        };
        var failCb = function (error) {
          options.onUploadFail(error);
        };
        var processCb = function (curr) {
          message.status = MsgStatus.UPLOADING;
          message.uploadingPercent = (curr * 100).toFixed(2);
          dispatcher.dispatch({
            type: ActionType.MSG_INFO_UPDATED,
            data: message
          });
        };

        fileHandler.init(WosInfo);
        data.file = file;
        if (msgType === 'video') {
          doVideoImgUpload(file, function () {
            fileHandler.upload(data, successCb, failCb, processCb);
          });
        } else if (msgType === 'file') {
          fileHandler.upload(data, successCb, failCb, processCb);
        }
      };
      getInitInfo(null, function (data) {
        if (!data) {
          options.onUploadFail(data);
          return;
        }
        doUpLoadFile(data);
      });
    };
    var downloadFile = function (message) {
      var onDownloadFail = function (error) {
        message.status = MsgStatus.DOWNLOAD_FAIL;
        if (error === '') {
          message.feedback = '您的网络未连接，请检查后重试。';
        }
        else {
          message.feedback = error.error_msg;
        }
        dispatcher.dispatch({
          type: ActionType.MSG_HANDLER_STATUS_CHANGE,
          data: message
        });
      };
      checkFile(message, function () {
        var fileContent = message.content;
        var fileUrl = fileContent.url;
        if (fileUrl) {
          message.status = MsgStatus.DOWNLOADING;
          message.feedback = '检查文件中...';
          dispatcher.dispatch({
            type: ActionType.MSG_HANDLER_STATUS_CHANGE,
            data: message
          });
          $.ajax({
            type: "GET",
            cache: false,
            url: fileUrl,
            data: "",
            success: function () {
              message.status = MsgStatus.DOWNLOADED;
              message.feedback = '';
              dispatcher.dispatch({
                type: ActionType.MSG_HANDLER_STATUS_CHANGE,
                data: message
              });
              fileHandler.downloadFromURL(fileUrl, fileContent.original_file_name);
            },
            error: function () {
              onDownloadFail({ error_msg: '文件失效！' });
            }
          });
          //fileHandler.downloadFromURL(fileUrl, fileContent.original_file_name);
        } else {
          onDownloadFail({ error_msg: '文件地址非法！' });
        }
      }, function (error) {
        onDownloadFail(error);
      });
    };
    var cancelSendFile = function (message) {
      var wos_file_name = message.content.wos_file_name;
      fileHandler.cancelUpload(wos_file_name);
      delete fileHunterBack[wos_file_name];
      message.status = MsgStatus.CANCEL_SENDING;
      message.feedback = '文件已取消发送!';
      dispatcher.dispatch({
        type: ActionType.MSG_SEND_STATUS_CHANGE,
        data: message
      });
    };
    var videoPlay = function (message) {
      var onvideoPlayFail = function (error) {
        dispatcher.dispatch({
          type: ActionType.VIDEO_PLAY_ERROR,
          data: {
            msg: message,
            error: error
          }
        });
      };
      checkFile(message, function () {
        var videoplayer = _getVideoPlayer.call(self);
        videoplayer.play(message);
      }, function (error) {
        onvideoPlayFail(error);
      });
    };
    var send = function (message, success, fail) {
      // 对于图片、文件先上传
      var onUploadBegin = function () {
        message.status = MsgStatus.UPLOADING;
        dispatcher.dispatch({
          type: ActionType.MSG_SEND_STATUS_CHANGE,
          data: message
        });
      };
      var onUploadSuccess = function (message) {
        config['msg-send-converter'](message);
      };
      var onUploadFail = function (error) {
        message.status = MsgStatus.UPLOAD_FAIL;
        if (error === '') {
          message.feedback = '您的网络未连接，请检查后重试。';
        }
        else {
          var feedbackText = '';
          switch (message.content.type) {
            case 'image':
              feedbackText = '图片上传失败，请重试。';
              break;
            case 'file':
              feedbackText = '文件上传失败，请重试。';
              break;
            case 'video':
              feedbackText = '视频上传失败，请重试。';
              break;
            default:
              break;
          }
          message.feedback = feedbackText;
          dispatcher.dispatch({
            type: ActionType.TOAST_SHOW,
            data: {
              content: '您的网络未连接，请检查后重试。',
              interval: 3000
            }
          });
        }
        dispatcher.dispatch({
          type: ActionType.MSG_SEND_STATUS_CHANGE,
          data: message
        });
      };
      var onHunterCheckFail = function (options) {
        var error = options.error;
        var wos_file_name = options.wos_file_name;
        fileHunterBack[wos_file_name] = {
          ret: error.error_code,
          isSent: false,
          msg: message
        };
        var resendMsg = function () {
          if (fileHunterBack[wos_file_name].msg.status != MsgStatus.CANCEL_SENDING) {
            fileHunterBack[wos_file_name].isSent = true;
            sendMsg(fileHunterBack[wos_file_name].msg, success, fail);
            delete fileHunterBack[wos_file_name];
          }
        };
        if (error.error_code + '' === '43002') {
          // 文件审核中 等待长连接下发审核结果
          var maxWaitTime = 5 * 1000;  // 5s等待长连接下发审核结果
          var waitTime = setTimeout(function () {
            var fileHunterBackObj = fileHunterBack[wos_file_name];
            if (fileHunterBackObj && !fileHunterBackObj.isSent) {
              resendMsg();
            }
            clearTimeout(waitTime);
          }, maxWaitTime);
        } else {
          resendMsg();
        }
      };

      var msgType = message.content.type;
      var msgUrl = message.content.url ? message.content.url : null;
      var is_forward_msg = message.is_forward_msg;
      delete message.is_forward_msg;
      if (msgType === 'image' && msgUrl && msgUrl.indexOf('http') === -1 && !is_forward_msg) {
        onUploadBegin();
        imageUploader.init();
        var suffix = msgUrl.split(';base64,')[0].split('data:image/')[1];
        var uploadParams = {
          sender_id: message.sender_id || message.sender_info.user_id,
          sender_source: message.sender_source || message.sender_info.user_source,
          to_id: message.to_id,
          to_source: message.to_source,
          file_suffixs: [suffix]
        }
        self._biz.getPicUploadUrl(uploadParams, function(res) {
          console.log(res, '=====')
          imageUploader.upload({
            msg_url: msgUrl,
            upload_url: res[0]
          }, function (url) {
            message.content.url = url;
            onUploadSuccess(message);
            sendMsg(message, success, fail)
          }, function (error) {
            onUploadFail(error);
          });
        }, function (err) {
          console.log(err, 'err=====')
          onUploadFail(err);
        })
        // imageUploader.upload(msgUrl, function (url) {
        //   message.content.url = url;
        //   onUploadSuccess(message);
        //   sendMsg(message, success, fail)
        // }, function (error) {
        //   onUploadFail(error);
        // });
      } else if (['video', 'file'].indexOf(msgType) !== -1 && msgUrl && ((typeof msgUrl !== 'string') || msgUrl.indexOf('http') === -1) && !is_forward_msg) {
        onUploadBegin();
        var options = {
          message: message,
          file: message.content.url,
          onUploadSuccess: onUploadSuccess,
          onUploadFail: onUploadFail,
          onHunterCheckFail: onHunterCheckFail
        };
        uploadFile(options);
      } else {
        sendMsg(message, success, fail);
      }
    };
    dispatcher.register(function (action) {
      /*
        type: "MSG_SEND_APPLY",
        data: {
          at_info: ""
          content: {msg: '4', type: 'text'}
          msg_type: 2
          sender_id: null
          sender_source: null
          shop_id: undefined
          shop_source: undefined
          show_type: "text"
          to_id: "ZP_D1EE26F3E451C1AE8F892D7C6D"
          to_source: 108
        }
       */
      switch (action.type) {
        case ActionType.MSG_SEND_APPLY:
          var message = action.data;
          var me = self._biz.me();
          message.temp_msg_id = --_temp_msg_id;
          message.send_time = new Date().getTime();
          message = config['msg-send-converter'](message);

          var sender_id = message.sender_id ? message.sender_id : me.user_id;
          var sender_source = message.sender_id ? message.sender_source : me.user_source;
          config['getUserinfo']([{
            user_id: message.to_id,
            user_source: message.to_source,
            shop_id: message.shop_id,
            shop_source: message.shop_source
          }, {
            user_id: sender_id,
            user_source: sender_source
          }], function (contacts) {
            message.sender_info = contacts[sender_id + '@' + sender_source];
            message.to_info = contacts[message.to_id + '@' + message.to_source];
            _temp_msgs[message.temp_msg_id] = message;
            send(message, () => {
              if (message.show_type === "msg_batch_forward_card" && !isEmpty(message.leaveMsg)) {
                dispatcher.dispatch({
                  type: ActionType.MSG_SEND_APPLY,
                  data: message.leaveMsg
                });
              }
            });
          });
          break;
        case ActionType.MSG_BATCH_SEND_APPLY:
          var messages = action.data.messages;
          var leave_msg = action.data.leaveMsg;
          var me = self._biz.me();
          var sender_id;
          var sender_source;
          var id_sources = [];
          var id_sources_map = {};
          messages.forEach(function (message) {
            message.temp_msg_id = --_temp_msg_id;
            message.send_time = new Date().getTime();
            message = config['msg-send-converter'](message);
            sender_id = message.sender_id ? message.sender_id : me.user_id;
            sender_source = message.sender_id ? message.sender_source : me.user_source;
            id_sources.push({
              user_id: message.to_id,
              user_source: message.to_source,
              shop_id: message.shop_id,
              shop_source: message.shop_source
            });
            if (!id_sources_map[sender_id + '@' + sender_source]) {
              id_sources_map[sender_id + '@' + sender_source] = true;
              id_sources.push({
                user_id: sender_id,
                user_source: sender_source
              });
            }
          });
          var promises_send = [];
          var success_send_num = 0;
          config['getUserinfo'](id_sources, function (contacts) {
            messages.forEach(function (message) {
              sender_id = message.sender_id ? message.sender_id : me.user_id;
              sender_source = message.sender_id ? message.sender_source : me.user_source;
              message.sender_info = contacts[sender_id + '@' + sender_source];
              message.to_info = contacts[message.to_id + '@' + message.to_source];
              _temp_msgs[message.temp_msg_id] = message;
              promises_send.push(new Promise(function (resolve, reject) {
                send(message, function () {
                  success_send_num += 1;
                  resolve();
                }, function () {
                  resolve();
                });
              }));
            });
            Promise.all(promises_send).then(function (result) {
              if (success_send_num === messages.length) {
                if (!isEmpty(leave_msg)) {
                  dispatcher.dispatch({
                    type: ActionType.MSG_SEND_APPLY,
                    data: leave_msg
                  });
                }
                dispatcher.dispatch({
                  type: ActionType.TOAST_SHOW,
                  data: {
                    content: '已转发',
                    interval: 3000,
                    type: 'new',
                    iconStatus: 'success'
                  }
                });
              }
            });
          });
          break;
        case ActionType.MSG_RESEND_APPLY:
          var msg2resend = _temp_msgs[action.data.temp_msg_id];
          if (msg2resend) {
            if (msg2resend.forward_original_content && msg2resend.forward_original_show_type) {
              msg2resend.content = msg2resend.forward_original_content;
              msg2resend.show_type = msg2resend.forward_original_show_type;
              delete msg2resend.forward_original_content;
              delete msg2resend.forward_original_show_type;
            }
            send(msg2resend);
          }
          break;
        case ActionType.MSG_SEND_STATUS_CHANGE:
          var param = {
            user_id: action.data.to_id,
            user_source: action.data.to_source
          }
          var isHasShopId = false;
          if (!isEmpty(action.data.shop_id) && !isEmpty(action.data.shop_source)) {
            param.shop_id = action.data.shop_id;
            param.shop_source = action.data.shop_source;
            isHasShopId = true;
          }
          config['getUserinfo']([param], function (contactResult) {
            var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
            var contact = contactResult[userKey];
            if (isHasShopId) {
              contact.shop_id = param.shop_id;
              contact.shop_source = param.shop_source;
            }
            if (!contact)
              return;
            session.changeLastMsg(contact.user_id, contact.user_source, $.extend(true, {}, action.data));
          });
          break;
        case ActionType.IMAGE_CLICK:
          var current_session = !isEmpty(self._currentcontact) ? (self._currentcontact.user_id + '@' + self._currentcontact.user_source) : null;
          if (current_session && !isEmpty(self._children[current_session]) && !isEmpty(self._children[current_session]._children['msgViewer']) && self._children[current_session]._children['msgViewer']._options.multiple_selectable) break;
          // 点击事件延迟
          var timer = setTimeout(function () {
            if (!self._children['image-viewer']) {
              self._children['image-viewer'] = new ImageViewer();
              self._element.append(self._children['image-viewer'].getElement());
              self._children['image-viewer'].open(action.data);
            } else {
              self._children['image-viewer'].open(action.data);
            }
            clearTimeout(timer);
          }, 300);

          /*if (self._position == AppPosition.CENTER) {
           self._children['image-viewer'].open(action.data);
           }*/
          break;
        case ActionType.MSG_ACTION:
          var actionPostData = action.data.actionPostData;
          if (typeof actionPostData == 'string') {
            try {
              actionPostData = jsonHandler.parse(actionPostData);
            } catch (e) {
              actionPostData = {};
            }
          }
          actionPostData = $.extend(true, {
          }, actionPostData);
          var me = self._biz.me();
          var me_key = me.user_id + '@' + me.user_source;
          var sender_key = action.data.message
          if (!isEmpty(action.data.message)) {
            var sender_key = action.data.message.sender_id + '@' + action.data.message.sender_source;
            var to_key = action.data.message.to_id + '@' + action.data.message.to_source;
            if (sender_key != me_key && to_key != me_key && to_key == self._currentcontact.user_id + '@' + self._currentcontact.user_source) {
              return;
            }
          } else {
            return;
          }
          var is_shop_model = isShopModeUser(self._currentcontact);
          self._shop_biz.cardAjax(action.data.actionData, {
            shop_id: is_shop_model ? (isShopModeUserSource(action.data.message.sender_source) ? action.data.message.sender_id : action.data.message.to_id) : null,
            shop_source: is_shop_model ? (isShopModeUserSource(action.data.message.sender_source) ? action.data.message.sender_source : action.data.message.to_source) : null,
          }, actionPostData, function (data, msg) {
            var success_msg = msg;
            if (!isEmpty(action.data.actionData) && action.data.actionData.url === '/worker/bind/recover') {
              success_msg = '成功恢复绑定关系';
            }
            if (!isEmpty(success_msg)) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: success_msg,
                  interval: 3000
                }
              });
            }
          }, function (res, status) {
            if (!isEmpty(res) && !isEmpty(res.msg)) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: res.msg,
                  interval: 3000
                }
              });
            } else if (!isEmpty(status) && status == "error") {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: '网络已断开，请稍后再试',
                  interval: 3000
                }
              });
            }
            // else {
            //   dispatcher.dispatch({
            //     type: ActionType.TOAST_SHOW,
            //     data: {
            //       content: '请求失败',
            //       interval: 3000
            //     }
            //   });
            // }
          });
          break;
        case ActionType.REDIT_MSG:
          break;
        case ActionType.FULLSCREEN_OPEN:
          self.triggerEvent('fullscreenChanged', true);
          //console.log('[webimFullScren]image-upload/click-open');
          break;
        case ActionType.FULLSCREEN_CLOSE:
          self.triggerEvent('fullscreenChanged', false);
          //console.log('[webimFullScren]image-viewer/upload-close');
          break;
        case ActionType.MSG_AUDIO_READ:
          var audioplayer = _getAudioPlayer.call(self);
          audioplayer.play(action.data);
          // sdk确认消息已读
          if (action.data.play_time + '' === '0') {
            _ackMsgRead.call(self, action.data);
          }
          break;
        case ActionType.MSG_AUDIO_READ_END:
          var audioplayer = _getAudioPlayer.call(self);
          audioplayer.stop();
          break;
        case ActionType.SESSION_CLICK:
          if (action.data && action.data.contact) {
            self._gotoContact(action.data.contact);
            // ackShow
            // var contactKey = action.data.contact.user_id + '@' + action.data.contact.user_source;
            // if (!isEmpty(action.data.contact.shop_id) && !isEmpty(action.data.contact.shop_source)) {
            //   contactKey += '@@' + action.data.contact.shop_id + '@' + self.action.data.contact.shop_source;
            // }
            // falseNewsDic.falseMsgMinus(contactKey);
            if (!isEmpty(action.data) && !isEmpty(action.data.msg)) {
              var lastMsg = action.data.msg;
              var options = {
                sender_id: lastMsg.sender_id,
                sender_source: lastMsg.sender_source,
                msg_ids: [lastMsg.msg_id],
                to_id: lastMsg.to_id,
                to_source: lastMsg.to_source
              }
              self._biz.ackMsgShow(options, null, function (data) {
                // 对于店铺模式下，客服被分配走之后，无法清除未读数bug
                if (isShopModeUser(lastMsg, self._biz.me()) && data && data.error_code == 42034) {
                  let options = {
                    sender_id: lastMsg.sender_id,
                    sender_source: lastMsg.sender_source,
                    msg_id: lastMsg.msg_id,
                    to_id: lastMsg.to_id,
                    to_source: lastMsg.to_source
                  }
                  self._shop_biz && self._shop_biz.ackShown(options);
                }
              })
            }
          }
          // 埋点统计会话点击
          //var type = self._position == AppPosition.CENTER ? 'center_session_click' : 'normal_session_click';
          //stat.report(StatPoint[type]);
          break;
        case ActionType.PERSON_CHECK:
          self.chatTo(action.data.user_id, action.data.user_source, null, action.data.shop_id, action.data.shop_source);
          break;
        case ActionType.CREATE_GROUP_CHECK:
          // 新建群
          var params = {
            members: action.data
          }
          self._biz.createGroup(params, function (res) {
            setTimeout(function () {
              self.chatTo(res.user_id, res.user_source);
            }, 1000);
          })
          break;

        case ActionType.JOIN_GROUP_CHECK:
          // 加入群
          var params = {
            target_ggid: action.data.target_ggid,
            target_gsource: action.data.target_gsource,
            target_users: action.data.target_users
          }
          self._biz.inviteJoinGroup(params, function (res) {
            console.log('添加群成员成功');
            action.data.callback && typeof action.data.callback === 'function' && action.data.callback();
          }, function (res) {
            if (res && res.error_code == '44014')
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: res.error_msg,
                  interval: 3000
                }
              });
          })
          break;
        case ActionType.QUIT_GROUP:
          // 退出群
          var params = {
            target_gid: action.data.target_gid,
            target_gsource: action.data.target_gsource
          }
          // 寻找删除群组之后，默认的下一个联系人
          var sessions = self._biz.getAllSessions();
          var targetDelKey = params.target_gid + '@' + params.target_gsource;
          var nextSelectIndex;
          var sessionsLen = sessions.length;
          $.each(sessions, function (index, session) {
            var sessionKey = session.user.user_id + '@' + session.user.user_source;
            if (sessionKey === targetDelKey) {
              nextSelectIndex = index == sessionsLen - 1 ? index - 1 : index + 1;
              return false;
            }
          })
          var contact;
          if (!_isEmpty(nextSelectIndex) && nextSelectIndex > -1 && !_isEmpty(sessions[nextSelectIndex]) && !_isEmpty(sessions[nextSelectIndex].user)) {
            contact = {
              user_id: sessions[nextSelectIndex].user.user_id,
              user_source: sessions[nextSelectIndex].user.user_source
            }
          }
          asynstore.stop();
          self._biz.quitGroup(params, function (res) {
            var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
            self._children[current_session].getElement().find('.im-panel-container').hide();
            self._children[current_session].unactive();
            self._children[current_session].destroy();
            delete self._children[current_session];
            if (!isEmpty(contact)) {
              session.setChecked(contact.user_id, contact.user_source, contact);
              asynstore.setSession(contact);
            } else {
              self._currentcontact = null;
            }
            asynstore.start();
          })
          break;
        case ActionType.DISBAND_GROUP:
          // 退出群
          var params = {
            target_gid: action.data.target_gid,
            target_gsource: action.data.target_gsource
          }
          self._biz.disbandGroup(params, function (res) {
            var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
            self._children[current_session].getElement().find('.im-panel-container').hide();
            var delSessionKey = localStorage.getItem("delSessionKey") ? localStorage.getItem("delSessionKey") + ',' + current_session : current_session;
            localStorage.setItem("delSessionKey", JSON.stringify(delSessionKey));
          })
          break;
        case ActionType.GET_GROUP_QRCODE:
          // 群二维码
          var params = {
            gid: action.data.gid,
            gsource: action.data.gsource
          }
          self._biz.getQrcodeId(params, function (res) {
            // 生成二维码
            var CryptoJS = window.CryptoJS;
            var key = CryptoJS.enc.Utf8.parse('w&ub#@a9%0#*&8#a');
            var iv = CryptoJS.enc.Utf8.parse('w@ch*a89*$@09a#*');
            var encrypt = function (word) {
              var srcs = CryptoJS.enc.Utf8.parse(word);
              var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
              var encryptedDataStr = encrypted.toString();
              return encryptedDataStr;
            }

            /**
             * 解密
             * @param word
             * @returns {*}
             */
            var decrypt = function (word) {
              var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
              var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
              var decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
              var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
              return decryptedStr.toString();
            }
            var params = {
              type: 'group',
              data: {
                id: action.data.gid,
                source: action.data.gsource,
                qrId: res.id
              }
            }
            var aseEncryptData = encrypt(jsonHandler.stringify(params));
            // 生成二维码图片
            $(".im-qrcode-continer").show();
            $(".im-qrcode").qrcode({
              width: 200, //宽度
              height: 200, //高度
              correctLevel: 2,
              typeNumber: -1,//计算模式
              background: "#ffffff",//背景颜色
              foreground: "#000000",
              text: aseEncryptData //任意内容
            });
            /*  var opts = {
               gid: action.data.gid,
               gsource: action.data.gsource,
               qrcode_id: res.id
             }
             self._biz.getQrcodeInfo(opts, function (res) {
               console.log('二维码信息', res);
             }) */
          })
          break;
        case ActionType.GROUP_NOTICE:
          // 群公告
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          var me = self._biz.me();
          var params = {
            target_id: action.data.gid,
            target_source: action.data.gsource,
            notice: {
              user_id: me.user_id,
              user_source: me.user_source,
              create_time: new Date().getTime(),
              content: action.data.group_notice
            }
          }
          self._biz.updateGroup(params, function (res) {
            // todo 群公告
            console.log('群公告成功');
            self._children[current_session].panel.resetPanel('group_notice', action.data.group_notice);
            self._children[current_session].getElement().find('.im-panel-container').hide();
          }, function () {
            self._children[current_session].panel.resetPanel('group_notice', action.data.old_group_notice);
          });
          break;
        case ActionType.CONFIRM_INVITE:
          // 群邀请确认
          self._biz.confirmInvite(action.data, function (res) {
            // todo 群邀请确认成功
            var text = '群聊邀请确认成功';
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: text,
                interval: 2000
              }
            });
          }, function () {
            var text = '群聊邀请确认失败';
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: text,
                interval: 2000
              }
            });
          })
          break;
        case ActionType.SES_TOP:
          // 置顶
          self._biz.msgSet(action.data, function (res) {
            var key = action.data.target_id + '@' + action.data.target_source;
            var txt = action.data.msg_set.ses_top == 1 ? '取消置顶' : '置顶';
            self._children[key].updateHandleText(txt);
            var ct = self._children[key];
            if (!isEmpty(self._currentcontact) && !isEmpty(self._currentcontact.msg_set) && !isEmpty(self._currentcontact.msg_set.ses_top)) {
              self._currentcontact.msg_set.ses_top = action.data.msg_set.ses_top;
            }
            !!ct && ct.setContact(self._currentcontact);
          }, function (res) {
            if (res && res.error_code == '41114')
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: res.error_msg,
                  interval: 3000
                }
              });
          })
          break;
        case ActionType.SET_SILENT:
          // 免打扰
          self._biz.msgSet(action.data, function (res) {
            var key = action.data.target_id + '@' + action.data.target_source;
            var txt = action.data.msg_set.silent == 1 ? '取消免打扰' : '免打扰';
            self._children[key].updateHandleText(txt);
            var ct = self._children[key];
            if (!isEmpty(self._currentcontact) && !isEmpty(self._currentcontact.msg_set) && !isEmpty(self._currentcontact.msg_set.silent)) {
              self._currentcontact.msg_set.silent = action.data.msg_set.silent;
            }
            !!ct && ct.setContact(self._currentcontact);
          })
          break;
        case ActionType.SET_GROUP:
          // 群设置
          var _me = self._biz.me();
          var group_id = action.data.group_id;
          var source_id = action.data.group_source;
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          // var group_notice = self._currentcontact.group_info ? self._currentcontact.group_info.notice : '{}';
          // group_notice = jsonHandler.parse(group_notice).content;
          self._children[current_session].panel.toggle();
          if (self._children[current_session].panel._opened) {
            self._biz.getGroupInfo({
              ids: [{
                user_id: group_id,
                user_source: source_id
              }],
              forceUpdate: false
            }, function (groupInfo) {
              var group_info = groupInfo[group_id + '@' + source_id].group_info;
              var group_notice = group_info ? group_info.notice : '{}';
              group_notice = jsonHandler.parse(group_notice).content;
              self._biz.groupAtContacts(self._currentcontact.user_id, self._currentcontact.user_source, function (contacts, id_sources, count) {
                self._children[current_session].panel.setData({
                  contacts: contacts,
                  id_sources: id_sources,
                  count: count,
                  pageIndex: 0,
                  group_name: action.data.group_name,
                  group_notice: group_notice,
                  user_id: _me.user_id,
                  user_source: _me.user_source
                });
                self._children[current_session].panel.setValue();
                self._children[current_session].getElement().find('.im-panel-container').show();
              }, true);
            });
          } else {
            self._children[current_session].getElement().find('.im-panel-container').hide();
          }
          break;
        case ActionType.UPDATE_GROUPNAME:
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          self._biz.updateGroup({
            target_id: self._currentcontact.user_id,
            target_source: self._currentcontact.user_source,
            user_name: action.data.group_name
          }, function () {
            self._children[current_session].panel.resetPanel('group_name', action.data.group_name);
            self._children[current_session].getElement().find('.im-panel-container').hide();
          }, function () {
            self._children[current_session].panel.resetPanel('group_name', action.data.old_group_name);
          });
          break;
        case ActionType.UPDATE_NICKNAME:
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          self._biz.manageGroupMember({
            target_gid: self._currentcontact.user_id,
            target_gsource: self._currentcontact.user_source,
            members: [
              {
                user_id: action.data.user_id,
                user_source: action.data.user_source,
                nick_name: action.data.nick_name,
                authority: action.data.authority
              }
            ]
          }, function () {
            self._children[current_session].panel.resetPanel('nick_name', action.data.nick_name);
            self._children[current_session].getElement().find('.im-panel-container').hide();

            //config['getUserinfo']([{
            //   user_id: action.data.user_id,
            //   user_source: action.data.user_source
            // }], function (user) {
            //   debugger;
            //   var userKey = action.data.user_id + '@' + action.data.user_source;
            //   user[userKey].remark.nick_name = action.data.nick_name;
            // });

            // self._biz.deleteAtContactsMember(current_session, [{
            //   user_id: action.data.user_id,
            //   user_source: action.data.user_source,
            //   nick_name: action.data.nick_name
            // }]);
          }, function () {
            self._children[current_session].panel.resetPanel('nick_name', action.data.old_nick_name);
          });
          break;
        case ActionType.ADD_MEMBER_WIN:
          $('.im-app').append($(groupTemplate));
          var organizstructure = new OrganizStructure({
            ele: $('.im-organization-list.add-group'),
            isAddGroup: true,
            contact: self._currentcontact,
            unavailableGroup: action.data.contacts
          });
          organizstructure.showTp($('.im-contactwindow-organization.add-group'));
          organizstructure.addEventListener('structureUnmount', function (handleType) {
            if (handleType == 'join') {
              var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
              self._children[current_session].getElement().find('.im-panel-container').hide();
            }
            organizstructure = null;
          });
          break;
        case ActionType.DELETE_MEMBER_WIN:
          $('.im-app').append($(groupTemplate));
          var groupMembers = [];
          var member;
          if (action.data.id_sources && action.data.contacts) {
            for (var index = 0; index < action.data.id_sources.length; index++) {
              member = action.data.contacts[action.data.id_sources[index]];
              if (member) groupMembers.push({
                avatar: member.avatar,
                group_id: self._currentcontact.user_id,
                id: member.user_id,
                name: member.nick_name || member.user_name,
                name_spell: member.name_spell,
                open_id: -1,
                source: member.user_source,
                type: 2,
                user_name: member.user_name,
                user_type: 1
              });
            }
          }
          var organizstructure = new OrganizStructure({
            ele: $('.im-organization-list.add-group'),
            isDeleteGroup: true,
            contact: self._currentcontact,
            groupMembers: groupMembers,
            master: {
              user_id: self._biz.me().user_id,
              user_source: self._biz.me().user_source
            }
          });
          organizstructure.showTp($('.im-contactwindow-organization.add-group'));
          organizstructure.addEventListener('structureUnmount', function (type) {
            organizstructure = null;
          });
          break;
        case ActionType.DELETE_MEMBER:
          self._biz.manageGroupMember({
            target_gid: self._currentcontact.user_id,
            target_gsource: self._currentcontact.user_source,
            members: action.data.members
          }, function () {
            var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
            self._biz.deleteAtContactsMember(current_session, action.data.members);
            self._children[current_session].getElement().find('.im-panel-container').hide();
          }, function () {

          });
          break;
        case ActionType.ADD_BLACKLIST:
          self._biz.addBlackList(action.data.user_id, action.data.user_source);
          break;
        case ActionType.DEL_BLACKLIST:
          self._biz.delBlackList(action.data.user_id, action.data.user_source);
          break;
        case ActionType.IS_BLACKED_CHECK:
          self._biz.isBlacked(action.data.user_id, action.data.user_source, function (data) {
            var key = action.data.user_id + '@' + action.data.user_source;
            if (!isEmpty(action.data.shop_id) && !isEmpty(action.data.shop_source)) {
              key += '@@' + action.data.shop_id + '@' + action.data.shop_source;
            }
            var text;
            if (data.is_blacked + '' === '1') {
              text = '取消屏蔽';
            } else if (data.is_blacked + '' === '0') {
              text = '屏蔽';
            }
            self._children[key].updateHandleText(text);
          });
          break;
        case ActionType.COMPLAINTS:
          var xz_opts = {
            action_type: 'complaints',
            me: {
              user_id: self._biz.me().user_id,
              user_source: self._biz.me().user_source
            },
            contact: {
              user_id: action.data.user_id,
              user_source: action.data.user_source
            },
            xz_source: config['xz_source'] || config['xz-source']
          };
          infoQuaCheck(xz_opts, true);
          break;
        case ActionType.UPLOAD_AUDIT_CHANGE:
          var feedbackData = action.data;
          var wos_file_name = feedbackData.wos_file_name;
          var fileHunterBackObj = fileHunterBack[wos_file_name];
          if (fileHunterBackObj && !fileHunterBackObj.isSentt) {
            fileHunterBack[wos_file_name].isSent = true;
            sendMsg(fileHunterBack[wos_file_name].msg);
            delete fileHunterBack[wos_file_name];
          }
          break;
        case ActionType.FILE_DOWNLOAD:
          var current_session = !isEmpty(self._currentcontact) ? (self._currentcontact.user_id + '@' + self._currentcontact.user_source) : null;
          if (current_session && !isEmpty(self._children[current_session]) && !isEmpty(self._children[current_session]._children['msgViewer']) && self._children[current_session]._children['msgViewer']._options.multiple_selectable) break;
          downloadFile(action.data);
          break;
        case ActionType.FILE_SENDE_CANCEL:
          cancelSendFile(action.data);
          break;
        case ActionType.VIDEO_PLAY:
          var current_session = !isEmpty(self._currentcontact) ? (self._currentcontact.user_id + '@' + self._currentcontact.user_source) : null;
          if (current_session && !isEmpty(self._children[current_session]) && !isEmpty(self._children[current_session]._children['msgViewer']) && self._children[current_session]._children['msgViewer']._options.multiple_selectable) break;
          videoPlay(action.data);
          break;
        case ActionType.VIDEO_PLAY_ERROR:
          var message = action.data.msg;
          var error = action.data.error;
          message.status = MsgStatus.VIDEO_PLAY_ERROR;
          if (!error || error === '') {
            message.feedback = '您的网络异常，请检查后重试';
          }
          else {
            message.feedback = error.error_msg;
          }
          if (message.is_in_float_view && message.u_key && !isEmpty(self._children['float-controller'])) {
            var msg_view = self._children['float-controller'].getView(message.u_key);
            if (!isEmpty(msg_view) && msg_view._children && msg_view._children.msgViewer) {
              msg_view._children.msgViewer.updateMsg(message);
            }
          } else {
            dispatcher.dispatch({
              type: ActionType.MSG_HANDLER_STATUS_CHANGE,
              data: message
            });
          }
          break;
        case ActionType.CHAT_AUDIO:
          self._currentcontact.remark = {};
          var userId = self._currentcontact.user_id;
          self._biz.exchangeXid([userId], function (idsObj) {
            var concatInfo = $.extend(true, {}, self._currentcontact);
            concatInfo.user_id = idsObj[userId] ? idsObj[userId] : concatInfo.user_id;
            window.WebRTC && window.WebRTC.callerLoadWebRTC({ contact: concatInfo, callType: 1 });
          }, function () {
            window.WebRTC && window.WebRTC.callerLoadWebRTC({ contact: self._currentcontact, callType: 1 });
          })
          break;
        case ActionType.CHAT_VIDEO:
          var userId = self._currentcontact.user_id;
          self._biz.exchangeXid([userId], function (idsObj) {
            var concatInfo = $.extend(true, {}, self._currentcontact);
            concatInfo.user_id = idsObj[userId] ? idsObj[userId] : concatInfo.user_id;
            window.WebRTC && window.WebRTC.callerLoadWebRTC({ contact: concatInfo, callType: 2 });
          }, function () {
            window.WebRTC && window.WebRTC.callerLoadWebRTC({ contact: self._currentcontact, callType: 2 });
          })
          break;
        case ActionType.INPUT_CHANGE:
          /* 防抖 */
          var content = action.data.content;
          var group_id = action.data.to_id;
          var source_id = action.data.to_source;
          var me = self._biz.me();
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          let inpujt_change_closeFloat = function () {
            self._children[current_session].groupAtClose();
            self._children[current_session]._element.find('.im-chatwindow-float').hide();
          }
          clearTimeout(timer);
          timer = setTimeout(function () {
            var filter;
            var AtIndex;
            var EndIndex;
            var cut;
            var contacts;
            /* get group members */
            content = content.replace(/&nbsp;/gi, ' ');
            //换行处理
            content = content.replace(/<br>/gi, '\n');
            //&amp;处理
            content = content.replace(/&amp;/gi, '&');
            //content = content.replace('&nbsp;', '      ').replace('&nbsp', '     ');
            if (content.indexOf(' ') == 1) {
              inpujt_change_closeFloat();
              return;
            }
            var cursorIndex = utils.getCursortPosition(self._children[current_session]._element.find('.im-input-richtext')[0]);
            var inputContent = '';
            var calcuAtIndex = function(inputContent){
              for (var index = 0; index < inputContent.length; index++) {
                if (inputContent[index] == '@' && !(!isNaN(AtIndex) && index - AtIndex <= 1)) {
                  AtIndex = index;
                  EndIndex = AtIndex;
                  cut = false;
                }
                if (!isNaN(AtIndex) && EndIndex >= AtIndex && !cut) {
                  if (inputContent[index] == ' ') {
                    cut = true;
                    EndIndex = index;
                  }
                }
              }
            }
            if(content.indexOf('img')>0){
              //如果输入框里有表情，在计算@的位置时候需去掉表情计算，因为计算光标位置方法默认去掉表情位置
              var contentCopy = content.replace(/<img.*?(?:>|\/>)/g,'');
              inputContent = contentCopy;
            } else{
              inputContent = content;
            }
            calcuAtIndex(inputContent);
            if (AtIndex >= cursorIndex) {
              inpujt_change_closeFloat();
              return;
            }
            EndIndex = EndIndex == AtIndex ? (action.data.content.length + 1) : EndIndex;
            var edgeIndex = EndIndex > cursorIndex ? cursorIndex : EndIndex;
            if (!isNaN(AtIndex)) {
              filter = content.slice(AtIndex + 1, edgeIndex);
              //filter = filter.replace(/(^\s+)|(\s+$)/g,"");
              content_extra = content.slice(AtIndex + 1, cursorIndex).replace(filter, '');
              if (content_extra.length && content_extra != ' ' && content_extra != '  ') {
                inpujt_change_closeFloat();
                return;
              }
              self._biz.groupAtContacts(group_id, source_id, function (contacts, id_sources, count) {
                if (!isEmpty(contacts) && contacts[me.user_id + '@' + me.user_source]) {
                  delete contacts[me.user_id + '@' + me.user_source];
                  count--;
                }
                if (filter) {
                  self._biz.groupAtFilter(contacts, filter, function (result) {
                    if (result.count) {
                      self._children[current_session].groupAtWindowRefresh(result.data, result.list, result.count, filter);
                      self._children[current_session]._element.find('.im-chatwindow-float').show();
                    } else {
                      self._children[current_session].groupAtClose();
                      self._children[current_session]._element.find('.im-chatwindow-float').hide();
                    }
                  });
                } else if (count > 0) {
                  self._children[current_session].groupAtWindowRefresh(contacts, id_sources, count);
                  self._children[current_session]._element.find('.im-chatwindow-float').show();
                }
              });
            } else {
              self._children[current_session].groupAtClose();
              self._children[current_session]._element.find('.im-chatwindow-float').hide();
            }
          }, 200);
          break;
        case ActionType.PRIVATE_INPUT_CHANGE:
          if (isShopModeUser(self._currentcontact) || isAnonymousSession(self._currentcontact)) {
            return
          }
          var content = action.data.content;
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          let private_inpujt_change_closeFloat = function () {
            self._children[current_session].groupAtClose();
            self._children[current_session]._element.find('.im-chatwindow-float').hide();
          }
          clearTimeout(timer);
          timer = setTimeout(function () {
            content = content.replace(/&nbsp;/gi, ' ');
            content = content.replace(/<br>/gi, '\n');
            content = content.replace(/&amp;/gi, '&');
            if (content.indexOf(' ') == 1) {
              private_inpujt_change_closeFloat();
              return;
            }
            //光标位置
            var cursorIndex = utils.getCursortPosition(self._children[current_session]._element.find('.im-input-richtext')[0]);
            var AtIndex;
            var inputContent = '';
            if(content.indexOf('img')>0){
              //如果输入框里有表情，在计算@的位置时候需去掉表情计算，因为计算光标位置方法默认去掉表情位置
              var contentCopy = content.replace(/<img.*?(?:>|\/>)/g,'');
              inputContent = contentCopy;
            } else{
              inputContent = content;
            }
            for (var index = 0; index < inputContent.length; index++) {
              if (inputContent[index] == '@' && index === cursorIndex - 1) {
                AtIndex = index;
              }
            }
            console.log('=======AtIndex', AtIndex, cursorIndex)
            if (AtIndex >= cursorIndex || AtIndex === 'undefined') {
              private_inpujt_change_closeFloat();
              return;
            }
            if (!isNaN(AtIndex)) {
              console.log('展示艾特选择框')
              var CurContacts = {}, CurIdSources = [];
              CurContacts[current_session] = self._currentcontact;
              CurIdSources.push(current_session);
              console.log(self._currentcontact, 'self._currentcontact')
              self._children[current_session].groupAtWindowRefresh(CurContacts, CurIdSources, 1);
              self._children[current_session]._element.find('.im-chatwindow-float').show();

            } else {
              console.log('不展示艾特选择框')
              self._children[current_session].groupAtClose();
              self._children[current_session]._element.find('.im-chatwindow-float').hide();
            }
          }, 200);
          break;
        case ActionType.KEYBOARD_OUTPUT:
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
          self._children[current_session].keyboardInput(action.data.event);
          break;
        case ActionType.CARD_SEND_MESSAGE:
          dispatcher.dispatch({
            type: ActionType.MSG_SEND_APPLY,
            data: {
              to_id: action.data.to_id,
              to_source: action.data.to_source,
              shop_id: self._currentcontact.shop_id,
              shop_source: self._currentcontact.shop_source,
              sender_id: self._currentcontact.shop_id ? self._currentcontact.shop_id : null,
              sender_source: self._currentcontact.shop_source ? self._currentcontact.shop_source : null,
              show_type: 'text',
              content: { "msg": action.data.text, "type": "text" },
              msg_type: action.data.in_group && action.data.in_group + '' === '1' ? 1005 : 2,
              at_info: ""
            }
          });
          break;
        case ActionType.AI_SEND:
          dispatcher.dispatch({
            type: ActionType.MSG_SEND_APPLY,
            data: {
              to_id: action.data.to_id,
              to_source: action.data.to_source,
              shop_id: self._currentcontact.shop_id,
              shop_source: self._currentcontact.shop_source,
              sender_id: self._currentcontact.shop_id ? self._currentcontact.shop_id : null,
              sender_source: self._currentcontact.shop_source ? self._currentcontact.shop_source : null,
              show_type: 'text',
              content: { "msg": action.data.text, "type": "text" },
              msg_type: action.data.in_group && action.data.in_group + '' === '1' ? 1005 : 2,
              at_info: ""
            }
          });
          self._shop_biz.reportUserAction({
            shop_id: self._currentcontact.shop_id,
            shop_source: self._currentcontact.shop_source
          }, {
            shopId: self._currentcontact.shop_id,
            userId: action.data.to_id,
            action: 'assistantSend',
            actionData: '',
            qaLog: action.data.qalog
          }, function () {

          }, function () {

          });
          break;
        case ActionType.AI_COPY:
          self._shop_biz.reportUserAction({
            shop_id: self._currentcontact.shop_id,
            shop_source: self._currentcontact.shop_source
          }, {
            shopId: self._currentcontact.shop_id,
            userId: action.data.to_id,
            action: 'assistantCopy',
            actionData: '',
            qaLog: action.data.qalog
          }, function () {

          }, function () {

          });
          break;
        case ActionType.MSG_WITHDRAW:
          self._biz.withdrawMessage({
            sender_id: action.data.message.sender_info ? action.data.message.sender_info.user_id : action.data.message.sender_id,
            sender_source: Number(action.data.message.sender_info ? action.data.message.sender_info.user_source : action.data.message.sender_source),
            msg_id: action.data.message.msg_id,
            to_id: action.data.message.to_id,
            to_source: action.data.message.to_source
          }, function (data) {

          }, function (data) {
            if (data && data.error_msg) dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: data.error_msg,
                interval: 3000
              }
            });
          })
          break;
        case ActionType.MSG_CLICK:
          if (isEmpty(self._currentcontact.shop_id) || isEmpty(self._currentcontact.shop_source)) return;
          var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source + '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
          self._shop_biz.getAIPrompt({
            shop_id: self._currentcontact.shop_id,
            shop_source: self._currentcontact.shop_source
          }, {
            sender_id: action.data.message.sender_id,
            sender_source: action.data.message.sender_source,
            to_id: action.data.message.to_id,
            to_source: action.data.message.to_source,
            msg_id: action.data.message.msg_id,
            text: action.data.message.content.msg
          }, function (data) {
            self._children[current_session].updateNotices(data);
            if (!isEmpty(data) && !data.length) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: '未获取到智能回复！',
                  interval: 3000
                }
              });
            }
          }, function () {
            self._children[current_session].updateNotices([]);
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: '未获取到智能回复！',
                interval: 3000
              }
            });
          });
          break;
        case ActionType.SET_EVALUATE:
          self.setEvaluation(action.data.sendMsg, function () {
            var that = self;
            var text = '卡片发送成功';
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: text,
                interval: 2000
              }
            });
          }, function (err) {
            var text = err.error_msg;
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: text,
                interval: 2000
              }
            });
          })
          break;
        case ActionType.CLEAR_ALL_UNREAD_MSGS:
          var unread = self._biz.getAllUnreadAmount();
          //兼容iIE不支持 Object.values
          var OjbectValues = Object.keys(unread).map(function (key) { return unread[key]; });
          var unreadNum = OjbectValues.reduce((a, b) => isNaN(b) ? a : a + b, 0)
          self._biz.getSessionUnreadMsgCount(action.data, (res) => {
            if (res.count !== 0 || unreadNum !== 0) {//有未读数
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: '正在清除',
                  interval: 5000
                }
              });
              self.clearAllUnreadMsgs(action.data, (res) => {
                //清除成功
                var clearTimer = setTimeout(() => {
                  self._children['toast'].hide();
                  clearTimeout(clearTimer)
                }, 500)
              }, (err) => {
                let text = err.error_msg ? err.error_msg : '您的网络未连接，请检查后重试。'
                dispatcher.dispatch({
                  type: ActionType.TOAST_SHOW,
                  data: {
                    content: text,
                    interval: 3000
                  }
                });
              })
            } else {
              //没有未读数
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: '没有可清除的消息',
                  interval: 3000
                }
              });
            }
          }, function (err) {
            let text = err.error_msg ? err.error_msg : '您的网络未连接，请检查后重试。'
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: text,
                interval: 3000
              }
            });
          });

          break;
        case ActionType.GROUP_At_CONTACTS:
          var currentContact = self._currentcontact;
          var current_session = currentContact.user_id + '@' + currentContact.user_source;
          var ct = self._children[current_session];
          self._biz.groupAtContacts(currentContact.user_id, currentContact.user_source, function (contacts, id_sources, count) {
            ct._children['chatfloat'].renderContacts(contacts, id_sources);
          }, true);
          break;
        case ActionType.TOAST_SHOW:
          if (self._children['toast']) {
            self._children['toast'].hide();
          } else {
            var toast = new Toast();
            self.getElement().append(toast.getElement());
            self._children['toast'] = toast;
          }
          self._children['toast'].show(action.data);
          break;
        case ActionType.MODAL_WIN_SHOW:
          if (self._children['modalwin']) {
            self._children['modalwin'].hide();
          } else {
            var modalwin = new ModalWin();
            self.getElement().append(modalwin.getElement());
            self._children['modalwin'] = modalwin;
          }
          self._children['modalwin'].show(action.data);
          break;
        case ActionType.REPORT_MESSAGES:
          var client_msgs = !isEmpty(action.data.client_msgs) ? action.data.client_msgs : [];
          var show_failed = !isEmpty(action.data.show_failed) ? action.data.show_failed : [];
          self._biz.reportMessages({
            client_msgs: client_msgs,
            show_failed: show_failed
          })
          break;
        case ActionType.SET_USER_REMARK:
          self._biz.setUserRemark({
            target_id: self._currentcontact.user_id,
            target_source: self._currentcontact.user_source,
            remark: {
              business_source: action.data.business_source,
              remark_name: action.data.remark_name,
              remark_spell: action.data.remark_spell,
              remark_telephone: action.data.remark_telephone,
              remark_info: action.data.remark_info,
              description: action.data.description,
              nick_name: action.data.nick_name
            }
          }, function (data) {
            // 对于备注的用户，需要更新历史记录中的用户名
            console.log(action.data, 'action.data')
            var remarkUserKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source; 
            self._currentcontact.remark.remark_name = action.data.remark_name
            for (var key in _loadedGroupMsgsObj) {
              if (_loadedGroupMsgsObj[key][remarkUserKey]) {
                self._children[key] = null;
              }
            }
            if (data == undefined) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: "网络异常，请稍后重试！",
                  interval: 2000
                }
              });
            }
          }, function (data) {
            let text = data.error_msg ? data.error_msg : '设置用户备注失败，请稍后重试！';
            if (action.data.remark_name.length > 0) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: text,
                  interval: 2000
                }
              });
            }
          });
          break;
        case ActionType.PROVIDE_CONTACTINFO:
          var text = action.data ? action.data : '';
          var me = self._biz.me();

          new asynchPipe(function (resolve, reject) {
            self._biz.getContact(me.user_id, me.user_source, function (data) {
              //名称
              var nameInfo;
              if (data.remark) {
                nameInfo = data.remark.remark_name || data.user_name || '未知';
              } else {
                nameInfo = data.user_name || '未知';
              }
              resolve({
                text: text,
                avatarInfo: data.avatar ? data.avatar : isAnonymousSession(data) ? config['default-anonymous-avatar'] : config['default-avatar'],
                nameInfo: nameInfo,
                currentcontact: self._currentcontact
              })
            });
          }).then(function (contactData) {
            var _this = this;
            self._biz.getSelfContactinfo(null, function (res) {
              var selfContactinfoTel = res.tel ? res.tel : '';
              var selfContactinfoWechat = res.wechat ? res.wechat : '';
              contactData.selfContactinfoTel = selfContactinfoTel;
              contactData.selfContactinfoWechat = selfContactinfoWechat;
              self._children['contact-info-window'].setData(contactData);
              _this.resolve();
            }, function (err) {
              console.log('getSelfContactinfo  err', err)
              var errMsg;
              if (err === '') {
                errMsg = '您的网络未连接，请检查后重试。';
              }
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: errMsg,
                  interval: 3000
                }
              });
            })
          }).then(function () {
            self._children['contact-info-window'].show();
          })
          break;
        case ActionType.SEND_CONTACTINFO:
          var sendContactinfo = action.data;
          if (isEmpty(sendContactinfo)) return;
          self._biz.provideContactinfo(sendContactinfo, function (res) {
            console.log('provideContactinfo  success', res)
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: '您的联系方式已成功发给对方。',
                interval: 3000
              }
            });
          }, function (err) {
            console.log('provideContactinfo  err', err)
            let errMsg;
            //errMsg = err && err.error_msg || '您的网络未连接，请检查后重试。'
            if (err && err.error_code === 41119) {
              //需要显示重新已向对方提出申请的提示；error_msg
              errMsg = err && err.error_msg || '已向对方提出申请,无法重复发送'
            } else if (err && err.error_code === 41113) {
              errMsg = err.error_msg ? err.error_msg : '';
            } else if (err && err.error_code === 41103) {
              errMsg = err.error_msg ? err.error_msg : '';
            } else if (err === '') {
              errMsg = '您的网络未连接，请检查后重试。';
            }
            if (errMsg) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: errMsg,
                  interval: 3000
                }
              });
            }

          })
          break;
        case ActionType.ASK_CONTACTINFO:
          self._biz.askContactinfo({
            other_user_id: action.data.other_user_id || '',
            other_user_source: action.data.other_user_source || '',
          }, function (res) {
            console.log('askContactinfo  success', res)
          }, function (err) {
            console.log('askContactinfo  err', err)
            let errMsg;
            //errMsg = err && err.error_msg || '您的网络未连接，请检查后重试。'
            if (err && err.error_code === 41119) {
              //需要显示重新已向对方提出申请的提示；error_msg
              errMsg = err && err.error_msg || '已向对方提出申请,无法重复发送'
            } else if (err && err.error_code === 41113) {
              errMsg = err.error_msg ? err.error_msg : '';
            } else if (err && err.error_code === 41103) {
              errMsg = err.error_msg ? err.error_msg : '';
            } else if (err === '') {
              errMsg = '您的网络未连接，请检查后重试。';
            }
            if (errMsg) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: errMsg,
                  interval: 3000
                }
              });
            }
          })
          break;
        case ActionType.GLANCE_CONTACTINFO:
          //我的收藏的点击查看
          if ((action.data.msg_showtype && action.data.msg_showtype === "collect") || (action.data.msg_collect && action.data.msg_collect === "collect")) {
            var msg = action.data.msgs ? action.data.msgs[0] : action.data;
            var contactinfoData = {
              tel: msg.tel,
              wechat: msg.wechat,
              is_uptodate: msg.is_uptodate,
              msg_showtype: 'collect'
            }
            action.data.contactinfoData = contactinfoData;
            dispatcherAccurate.dispatch(dispatcherAccurate.createKey(action.data.msg_id), {
              type: ActionType.GLANCE_CONTACTINFO_RETURN,
              data: action.data
            });
            return
          }
          let glanceData = action.data.glanceData;
          self._biz.glanceContactinfo(glanceData, function (res) {
            action.data.contactinfoData = res
            dispatcherAccurate.dispatch(dispatcherAccurate.createKey(action.data.msg_id), {
              type: ActionType.GLANCE_CONTACTINFO_RETURN,
              data: action.data
            });
            var current_session = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
            if (self._children[current_session] && self._children[current_session]._children && self._children[current_session]._children.msgViewer) {
              var $msglist = self._children[current_session]._children.msgViewer._children.msglist
              var $msgViewer = self._children[current_session]._children.msgViewer
              if ($msglist.isLastMsg(action.data.msg_id)) {
                //需要滚动
                $msgViewer.scrollToBottom()
              }
            }
          }, function (err) {
            console.log('glanceContactinfo err', err)
            let errMsg;
            //errMsg = err && err.error_msg || '您的网络未连接，请检查后重试。'
            if (err && err.error_code === 41119) {
              //需要显示重新已向对方提出申请的提示；error_msg
              errMsg = err && err.error_msg || '已向对方提出申请,无法重复发送'
            } else if (err && err.error_code === 41113) {
              errMsg = err.error_msg ? err.error_msg : '';
            } else if (err && err.error_code === 41103) {
              errMsg = err.error_msg ? err.error_msg : '';
            } else if (err === '') {
              errMsg = '您的网络未连接，请检查后重试。';
            }
            if (errMsg) {
              dispatcher.dispatch({
                type: ActionType.TOAST_SHOW,
                data: {
                  content: errMsg,
                  interval: 3000
                }
              });
            }
          })

          break;
        case ActionType.CLOSE_ALL_FLOAT_VIEWS:
          if (!isEmpty(self._children['float-controller'])) {
            self._children['float-controller'].removeAll();
          }
          break;
        case ActionType.GET_MY_COLLECTION:
          dispatcher.dispatch({
            type: ActionType.CLOSE_ALL_FLOAT_VIEWS
          });
          if (!self._children['collect-info-window']) {
            self._children['collect-info-window'] = new myCollectWindow({
              getMoreCollectMsg: function (params, cb) {
                if (self._biz.isLogined()) {
                  self._biz.getCollection(params, function (res, have_more) {
                    cb(res.collections, have_more);
                  }, function (err) {
                    cb([]);
                  });
                } else {
                  var _this = this;
                  setTimeout(function () {
                    _this.getCollection(params, cb);
                  }, 100);
                }
              }
            });
            self._element.append(self._children['collect-info-window'].getElement());
          }
          //调接口 collection
          var params = {
            last_collect_id: action.data.last_collect_id ? action.data.last_collect_id : '',
            count: action.data.count ? action.data.count : 50,
            type: action.data.type ? action.data.type : '',
          }
          self._biz.getCollection(params, function (res, have_more) {
            self._children['collect-info-window'].setData({
              collections: res.collections,
              total: res.total,
              remained_size: res.remained_size,
              have_more: have_more
            });
            self._children['collect-info-window'].show();
          }, function (err) {
            console.log('getCollection err', err)
          })
          break;
        case ActionType.ADD_COLLECTION:
          var messages = [];
          var msgSize = 0;
          var vaildMsgs = [];
          var not_allowed_collect = false;
          var selected_messages = (action.data.messages || [])
          selected_messages.forEach(message => {
            if (message && message.msg_id && message.status !== 'FAIL' && non_collect_show_types.indexOf(message.show_type) < 0) {
              messages.push(message.msg_id)
              vaildMsgs.push(_extendMsgValidityHandler.call(self, message));
            } else {
              not_allowed_collect = true;
            }
          });
          if (not_allowed_collect && selected_messages.length === 1) {
            dispatcher.dispatch({
              type: ActionType.MODAL_WIN_SHOW,
              data: {
                title: '',
                content: '你选择的消息是特殊消息，无法收藏',
                showCancel: false,
                confirmText: '好的'
              }
            });
          } else if (not_allowed_collect) {
            dispatcher.dispatch({
              type: ActionType.MODAL_WIN_SHOW,
              data: {
                title: '',
                content: "你选择的消息中存在特殊消息，无法收藏",
                showCancel: false,
                confirmText: '好的'
              }
            });
          } else {
            //所有文件都有效之后获取大小
            Promise.all(vaildMsgs).then((res) => {
              var sizeMsgs = [];
              selected_messages.forEach(message => {
                if (!message.msg_id) return
                sizeMsgs.push(_getMsgSize.call(self, message))
              });
              Promise.all(sizeMsgs).then((sizes) => {
                sizes.forEach(size => {
                  msgSize += Number(size)
                });
                console.log('=====msgSize', msgSize)
                var _params = {
                  size: Number(msgSize) !== 0 ? Number(msgSize) : 10,
                  msgs: messages,
                  other_id: action.data.other_id
                }
                self._biz.collection(_params, function (res) {
                  console.log('collection success', res)
                  dispatcher.dispatch({
                    type: ActionType.MULTIPLE_MENU_CLOSE
                  });
                  dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                      content: '已收藏',
                      interval: 3000,
                      type: 'new',
                      iconStatus: 'success'
                    }
                  });
                }, function (err) {
                  var errText = err.error_msg ? err.error_msg : '您的网络未连接，请检查后重试。';
                  if (errText) {
                    dispatcher.dispatch({
                      type: ActionType.TOAST_SHOW,
                      data: {
                        content: errText,
                        interval: 3000,
                        type: 'new',
                        iconStatus: 'fail'
                      }
                    });
                  }
                })
              }).catch((err) => {
                var errText;
                errText = err && err.error_msg ? err.error_msg : 'size大小获取未知错误';
                if (errText) {
                  dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                      content: errText,
                      interval: 3000,
                      type: 'new',
                      iconStatus: 'fail'
                    }
                  });
                }

              })
            }).catch((err) => {
              var errText;
              if (err && err.error_code && err.error_code == '404') {
                errText = '只能收藏未过期的文本、图片、视频留言、文件、卡片、引用、聊天记录消息。'
                dispatcher.dispatch({
                  type: ActionType.MODAL_WIN_SHOW,
                  data: {
                    title: '收藏失败',
                    content: errText,
                    showCancel: false,
                    confirmText: '好的'
                  }
                });
                errText = null;
              } else if (err === '') {
                errText = '您的网络未连接，请检查后重试。'
              } else {
                errText = err && err.error_msg ? err.error_msg : '有效期设置未知错误';
              }
              if (errText) {
                dispatcher.dispatch({
                  type: ActionType.TOAST_SHOW,
                  data: {
                    content: errText,
                    interval: 3000,
                    type: 'new',
                    iconStatus: 'fail'
                  }
                });
              }

            })
          }
          break;
        case ActionType.DEL_COLLECTION:
          dispatcher.dispatch({
            type: ActionType.MODAL_WIN_SHOW,
            data: {
              title: '消息提醒',
              content: "是否删除选中消息?",
              showCancel: true,
              cancelText: '取消',
              confirmText: '确定',
              success: function (res) {
                if (res.confirm) {
                  console.log('用户点击确定')
                  var selected_message = action.data.message;
                  var collectIds = [selected_message.collect_id]
                  var _params = {
                    collect_ids: collectIds
                  }
                  self._biz.delCollection(_params, function (res) {
                    console.log('del collection success', res)
                    dispatcher.dispatch({
                      type: ActionType.TOAST_SHOW,
                      data: {
                        content: '删除收藏成功',
                        interval: 3000,
                        type: 'new',
                        iconStatus: 'success'
                      }
                    });
                    self._children['collect-info-window'].updateRemainedSize(res.total, res.remained_size);
                    self._children['collect-info-window'].delCollections(collectIds);
                    // 重新恢复文件的有效期(延期7天)
                    _extendMsgValidityHandler.call(self, selected_message, { no_extendMsgValidity: false, wos_file_expire: 168 });
                  }, function (err) {
                    console.log('del collection err', err)
                    var errText = err.error_msg ? err.error_msg : '您的网络未连接，请检查后重试。';
                    if (errText) {
                      dispatcher.dispatch({
                        type: ActionType.TOAST_SHOW,
                        data: {
                          content: errText,
                          interval: 3000,
                          type: 'new',
                          iconStatus: 'fail'
                        }
                      });
                    }
                  })
                } else if (res.cancel) {
                  console.log('用户点击取消')
                }
              },
              fail: function () {

              }
            }
          });
          break;
        case ActionType.MULTIPLE_FORWARD_WINDOW_CLOSE:
          if (!isEmpty(self._children['multipleForwardWindow'])) {
            self._children['multipleForwardWindow'].hide();
            self._children['multipleForwardWindow'].reset();
          }
          break;
        case ActionType.MULTIPLE_FORWARD_WINDOW_OPEN:
          if (!config['is_support_forward']) return;
          var vaildForwardMsgs = [];
          var forward_message;
          var not_allowed_forward = false;
          var not_allowed_anonymous_forward = false;
          var forward_messages = (action.data.messages || []).filter(function (message) {
            if (!not_allowed_anonymous_forward && message && message._data && message._data.msg && message._data.msg.sender_info) {
              not_allowed_anonymous_forward = !isShopModeUserSource(message._data.msg.sender_info.user_source) && (message._data.msg.sender_info.register !== 1);
            }
            if (message && message._data && message._data.msg && message._data.msg.msg_id && (isEmpty(message._data.msg.status) || message._data.msg.status === 'SUCCESS') && non_forward_show_types.indexOf(message._data.msg.show_type) < 0) {
              forward_message = message._data.msg;
              forward_message.forward_msg_id = forward_message.msg_id;
              vaildForwardMsgs.push(_extendMsgValidityHandler.call(self, forward_message, { no_extendMsgValidity: true }));
              return true;
            }
            not_allowed_forward = true;
            return false;
          });
          function goForward() {
            // 判断需转发的消息中是否有过期资源
            Promise.all(vaildForwardMsgs).then((res) => {
              if (isEmpty(self._children['multipleForwardWindow'])) {
                var multipleForwardWindow = new MultipleForwardWindow({
                  single_select: true,
                  getMoreSessions: function (params, cb) {
                    if (self._biz.isLogined()) {
                      self._biz.getSessionsFromApi(params, function (sessions, have_more) {
                        var list = [];
                        $.each(sessions, function (index, session) {
                          var userKey = session.user.user_id + '@' + session.user.user_source;
                          if (userKey == currentKey) {
                            return;
                          }
                          list.push(session.user);
                        });
                        config['getUserinfo'](list, function (contacts) {
                          cb(sessions, contacts, have_more);
                        });
                      }, function () {
                        cb([], {}, true);
                      });
                    } else {
                      cb([], true);
                    }
                  }
                });
                self._children['multipleForwardWindow'] = multipleForwardWindow;
                self._element.append(multipleForwardWindow.getElement());
              }
              var me = self._biz.me();
              var currentKey = me.user_id + "@" + me.user_source;
              var sessions = self._biz.getAllSessions();
              var list = [];
              $.each(sessions, function (index, session) {
                var userKey = session.user.user_id + '@' + session.user.user_source;
                if (userKey == currentKey || is_remind_helper(session.user.user_id, session.user.user_source, session.user.shop_id, session.user.shop_source)) {
                  return;
                }
                list.push(session.user);
              });
              config['getUserinfo'](list, function (contacts) {
                self._children['multipleForwardWindow'].reset();
                self._children['multipleForwardWindow'].setData({
                  sessions: sessions,
                  contacts: contacts,
                  messages: forward_messages,
                  forward_one_by_one: action.data.forward_one_by_one
                });
                self._children['multipleForwardWindow'].show();
              });
              //catch有效期设置的错误情况
            }).catch((err) => {
              var errText;
              if (err && err.error_code && err.error_code == '404') {
                errText = '只能转发未过期的文本、图片、视频留言、文件、卡片、引用、聊天记录消息。'
                dispatcher.dispatch({
                  type: ActionType.MODAL_WIN_SHOW,
                  data: {
                    title: '转发失败',
                    content: errText,
                    showCancel: false,
                    confirmText: '好的'
                  }
                });
                errText = null;
              } else if (err === '') {
                errText = '您的网络未连接，请检查后重试。'
              } else {
                errText = err && err.error_msg ? err.error_msg : '有效期检查失败';
              }
              if (errText) {
                dispatcher.dispatch({
                  type: ActionType.TOAST_SHOW,
                  data: {
                    content: errText,
                    interval: 3000,
                    type: 'new',
                    iconStatus: 'fail'
                  }
                });
              }
            });
          }
          if (not_allowed_anonymous_forward) {
            dispatcher.dispatch({
              type: ActionType.MODAL_WIN_SHOW,
              data: {
                title: '',
                content: '匿名用户消息不支持转发',
                showCancel: false,
                confirmText: '好的'
              }
            });
          } else if (not_allowed_forward && forward_messages.length === 0) {
            dispatcher.dispatch({
              type: ActionType.MODAL_WIN_SHOW,
              data: {
                title: '',
                content: '特殊消息不支持转发',
                showCancel: false,
                confirmText: '好的'
              }
            });
          } else if (not_allowed_forward) {
            dispatcher.dispatch({
              type: ActionType.MODAL_WIN_SHOW,
              data: {
                title: '',
                content: "你选择的消息中，特殊消息不支持转发， 是否继续?",
                showCancel: true,
                cancelText: '取消',
                confirmText: '发送',
                success: function (res) {
                  if (res.confirm) {
                    goForward();
                  }
                },
                fail: function () {

                }
              }
            });
          } else {
            goForward();
          }
          break;
        case ActionType.MULTIPLE_FORWARD_WINDOW_SUBMIT:
          if (!config['is_support_forward']) return;
          if (!isEmpty(self._children['multipleForwardWindow'])) {
            self._children['multipleForwardWindow'].hide();
            self._children['multipleForwardWindow'].reset();
            var messages = (action.data.messages || []).filter(function (message) {
              if (message && message._data && message._data.msg && (message._data.msg.msg_id > 0) && (isEmpty(message._data.msg.status) || message._data.msg.status === 'SUCCESS') && non_forward_show_types.indexOf(message._data.msg.show_type) < 0) {
                return true;
              }
              return false;
            });
            var toUsers = action.data.toUsers || [];
            var forward_one_by_one = action.data.forward_one_by_one;
            var is_shop_session = !isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source);
            var hasLeaveMsg = !isEmpty(action.data.leaveMsg);
            if (!isEmpty(messages) && messages.length) {
              var me = self._biz.me();
              if (forward_one_by_one) {
                toUsers.forEach(function (toUser) {
                  var send_data = {
                    to_id: toUser.user.user_id,
                    to_source: toUser.user.user_source,
                    shop_id: toUser.user.shop_id,
                    shop_source: toUser.user.shop_source,
                    sender_id: toUser.user.shop_id ? toUser.user.shop_id : me.user_id,
                    sender_source: toUser.user.shop_source ? toUser.user.shop_source : me.user_source,
                    msg_type: toUser.user.is_group ? 1005 : 2,
                    at_info: ""
                  }
                  var send_messages = [];
                  // 消息中有视频需要过信质校验
                  var notify_messages = [];
                  messages.forEach(function (message) {
                    if (message && message._data && message._data.msg && message._data.msg.content && (message._data.msg.content.type !== 'text' && message._data.msg.content.type !== 'image')) {
                      var content = message._data.msg.content;
                      var hunterOptions = {
                        wos_file_name: content.wos_file_name,
                        url: content.url,
                        type: content.type,
                        file_format: content.format,
                        file_size: content.size,
                        sender_id: send_data.sender_id,
                        sender_source: send_data.sender_source,
                        to_id: send_data.to_id,
                        to_source: send_data.to_source
                      };
                      notify_messages.push(notifyHunter.call(self, hunterOptions))
                    }
                  })
                  new asynchPipe(function(resolve, reject) {
                    Promise.all(notify_messages).then(function(res) {
                      resolve()
                    }, function(err) {
                      reject(err)
                    })
                  }).then(function() {
                    messages.forEach(function (message) {
                      if (message && message._data && message._data.msg && message._data.msg.content) {
                        let is_anonymous_msg = true;
                        if (message._data.msg.sender_info && message._data.msg.sender_info.register === 1) {
                          is_anonymous_msg = false;
                        }
                        if (isShopModeUserSource(message._data.msg.sender_info.user_source) && message._data.msg.sender_info.register !== 1) {
                          is_anonymous_msg = false;
                        }
                        if (is_anonymous_msg) {
                          return;
                        }
                        let sender_id = message._data.msg.sender_info ? message._data.msg.sender_info.user_id : message._data.msg.sender_id;
                        let sender_source = Number(message._data.msg.sender_info ? message._data.msg.sender_info.user_source : message._data.msg.sender_source);
                        let content_msgs = [{
                          msg_id: message._data.msg.msg_id,
                          sender_id: sender_id + '@@' + sender_source,
                          to_id: message._data.msg.to_id + '@@' + message._data.msg.to_source
                        }];
                        send_messages.push({
                          ...send_data,
                          ...{
                            show_type: 'msg_batch_forward_card',
                            content: {
                              type: "msg_batch_forward_card",
                              forward_one_by_one: true,
                              msgs: content_msgs
                            },
                            forward_msg_show_type: message._data.msg.show_type,
                            forward_msg_content: message._data.msg.content,
                            is_forward_msg: true
                          }
                        });
                      }
                    });
                    let batch_forward_data = {
                      messages: send_messages
                    };
                    if (hasLeaveMsg) {
                      batch_forward_data.leaveMsg = {
                        ...send_data,
                        ...{
                          show_type: "text",
                          content: {
                            msg: action.data.leaveMsg,
                            type: "text"
                          }
                        }
                      }
                    }
                    dispatcher.dispatch({
                      type: ActionType.MSG_BATCH_SEND_APPLY,
                      data: batch_forward_data
                    });
                  })
                });
              } else if (!forward_one_by_one) {
                new asynchPipe(function (resolve, reject) {
                  if (is_shop_session) {
                    self._shop_biz.getWorkerShops({
                      specialShops: [self._currentcontact.shop_id + '@@' + self._currentcontact.shop_source]
                    }, function (shop) {
                      resolve(shop[0]);
                    }, function () {
                      reject();
                    });
                  } else {
                    config['getUserinfo']([{
                      user_id: me.user_id,
                      user_source: me.user_source
                    }],
                      function (userInfo) {
                        if (!isEmpty(userInfo) && userInfo[me.user_id + '@' + me.user_source]) {
                          resolve(userInfo[me.user_id + '@' + me.user_source]);
                        } else {
                          reject();
                        }
                      });
                  }
                }).then(function (userInfo) {
                  var content_msgs = [];
                  var content_msgs_preview = [];
                  var shopName = (is_shop_session && userInfo) ? userInfo.shopName : '未知';
                  if (is_shop_session) {
                    card_title = self._currentcontact.user_name + '和' + shopName + '的聊天记录';
                  } else if (self._currentcontact.in_group) {
                    card_title = '群聊的聊天记录';
                  } else {
                    card_title = self._currentcontact.user_name + '和' + userInfo.user_name + '的聊天记录';
                  }
                  messages.forEach(function (message) {
                    if (message && message._data && message._data.msg && message._data.msg.content) {
                      let is_anonymous_msg = true;
                      if (message._data.msg.sender_info && message._data.msg.sender_info.register === 1) {
                        is_anonymous_msg = false;
                      }
                      if (isShopModeUserSource(message._data.msg.sender_info.user_source) && message._data.msg.sender_info.register !== 1) {
                        is_anonymous_msg = false;
                      }
                      if (is_anonymous_msg) {
                        return;
                      }
                      let sender_id = message._data.msg.sender_info ? message._data.msg.sender_info.user_id : message._data.msg.sender_id;
                      let sender_source = Number(message._data.msg.sender_info ? message._data.msg.sender_info.user_source : message._data.msg.sender_source);
                      content_msgs.push({
                        msg_id: message._data.msg.msg_id,
                        sender_id: sender_id + '@@' + sender_source,
                        to_id: message._data.msg.to_id + '@@' + message._data.msg.to_source
                      });
                      content_msgs_preview.push({
                        sender_name: (message._data.msg.sender_info ? message._data.msg.sender_info.user_name : (is_shop_session ? shopName : '未知')),
                        content: JSON.stringify(message._data.msg._original_content || message._data.msg.content)
                      });
                    }
                  });
                  if (content_msgs.length && content_msgs_preview.length) {
                    toUsers.forEach(function (toUser) {
                      if (!isEmpty(toUser.user)) {
                        var send_data = {
                          to_id: toUser.user.user_id,
                          to_source: toUser.user.user_source,
                          shop_id: toUser.user.shop_id,
                          shop_source: toUser.user.shop_source,
                          sender_id: toUser.user.shop_id ? toUser.user.shop_id : me.user_id,
                          sender_source: toUser.user.shop_source ? toUser.user.shop_source : me.user_source,
                          msg_type: toUser.user.is_group ? 1005 : 2,
                          at_info: ""
                        }
                        let batch_forward_data = {
                          ...send_data,
                          ...{
                            show_type: 'msg_batch_forward_card',
                            content: {
                              type: "msg_batch_forward_card",
                              forward_one_by_one: false,
                              msgs: content_msgs,
                              msgs_preview: content_msgs_preview,
                              card_title: card_title
                            },
                          },
                        };
                        if (hasLeaveMsg) {
                          batch_forward_data.leaveMsg = {
                            ...send_data,
                            ...{
                              show_type: "text",
                              content: {
                                msg: action.data.leaveMsg,
                                type: "text"
                              }
                            }
                          }
                        }
                        dispatcher.dispatch({
                          type: ActionType.MSG_SEND_APPLY,
                          data: batch_forward_data
                        });
                      }
                    });
                    dispatcher.dispatch({
                      type: ActionType.TOAST_SHOW,
                      data: {
                        content: '已转发',
                        interval: 3000,
                        type: 'new',
                        iconStatus: 'success'
                      }
                    });
                  }
                });
              }
            }
            dispatcher.dispatch({
              type: ActionType.MULTIPLE_MENU_CLOSE
            });
          }
          break;
        case ActionType.MULTIPLE_MENU_CLOSE:
          var current_session = !isEmpty(self._currentcontact) ? (self._currentcontact.user_id + '@' + self._currentcontact.user_source) : null;
          if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
            current_session += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
          }
          if (current_session && !isEmpty(self._children[current_session]) && !isEmpty(self._children[current_session]._children['msgViewer'])) {
            self._children[current_session]._element.find('.im-multiplemenu-container').hide();
            self._children[current_session]._children['msgViewer'].multiple_cancel();
          }
          break;
        case ActionType.FORWARD_MESSAGE_FLOAT:
          if (!config['is_support_forward']) return;
          if (isEmpty(self._children['float-controller'])) return;
          if (!isEmpty(action.data.parent_u_key) && self._children['float-controller']._children && !isEmpty(self._children['float-controller']._children[action.data.parent_u_key]) && self._children['float-controller']._children[action.data.parent_u_key]._options.stage === 2) {
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: '多层嵌套的消息只能展开两层',
                interval: 3000,
                type: 'new',
                iconStatus: 'fail'
              }
            });
            return
          };
          var current_session = !isEmpty(self._currentcontact) ? (self._currentcontact.user_id + '@' + self._currentcontact.user_source) : null;
          if (current_session && !isEmpty(self._children[current_session]) && !isEmpty(self._children[current_session]._children['msgViewer']) && self._children[current_session]._children['msgViewer']._options.multiple_selectable) break;
          if (action.data.id && self._children['float-controller']._children[action.data.id]) {
            self._children['float-controller'].setTop(action.data.id);
          } else {
            var get_forward_params = {
              forward_msg_id: action.data.id,
              forward_sender_id: action.data.sender_id,
              forward_sender_source: action.data.sender_source,
              forward_to_id: action.data.to_id,
              forward_to_source: action.data.to_source,
              msgs: action.data.msg_ids
            }
            if (action.data.root_u_key) {
              var msg_view = self._children['float-controller'].getView(action.data.root_u_key);
              if (!isEmpty(msg_view) && msg_view._options && msg_view._options._forward_data) {
                get_forward_params.forward_msg_id = msg_view._options._forward_data.forward_msg_id,
                  get_forward_params.forward_sender_id = msg_view._options._forward_data.forward_sender_id,
                  get_forward_params.forward_sender_source = msg_view._options._forward_data.forward_sender_source,
                  get_forward_params.forward_to_id = msg_view._options._forward_data.forward_to_id,
                  get_forward_params.forward_to_source = msg_view._options._forward_data.forward_to_source
              }
            }
            self._biz.getForwardMsg(get_forward_params, function (forward_messages) {
              var new_view = new FloatView({
                _u_key: action.data.id,
                _parent_u_key: action.data.parent_u_key,
                _forward_data: !action.data.parent_u_key ? get_forward_params : {}
              });
              var id_sources = action.data.id_sources || {};
              self._children['float-controller'].addView(new_view, {
                initTop: self._position == AppPosition.CENTER ? 105 : 60,
                initLeft: self._position == AppPosition.CENTER ? 299.5 : 170
              });
              var last_sender_id_source;
              (forward_messages || []).forEach(function (forward_message) {
                forward_message = Object.assign(forward_message, (id_sources[forward_message.msg_id] || {}));
                if (last_sender_id_source === forward_message.sender_id + '@' + forward_message.sender_source) {
                  forward_message.isSameUserWithPrevious = true;
                }
                last_sender_id_source = forward_message.sender_id + '@' + forward_message.sender_source;
              });
              new_view.setData({
                msgList: forward_messages,
                title: action.data.title
              })
            }, function (err) {
              var errMsg;
              if (err && err.error_msg) {
                errMsg = err.error_msg
              } else if (err === '') {
                errMsg = '您的网络未连接，请检查后重试。'
              }
              if (errMsg) {
                dispatcher.dispatch({
                  type: ActionType.TOAST_SHOW,
                  data: {
                    content: errMsg,
                    interval: 3000
                  }
                });
              }
            });
          }
          break;
        case ActionType.COLLECTION_MESSAGE_FLOAT:
          if (action.data.id && self._children['float-controller']._children[action.data.id]) {
            self._children['float-controller'].setTop(action.data.id);
            return
          }
          if (!isEmpty(action.data.parent_u_key) && self._children['float-controller']._children && !isEmpty(self._children['float-controller']._children[action.data.parent_u_key]) && self._children['float-controller']._children[action.data.parent_u_key]._options.stage === 2) {
            dispatcher.dispatch({
              type: ActionType.TOAST_SHOW,
              data: {
                content: '多层嵌套的消息只能展开两层',
                interval: 3000,
                type: 'new',
                iconStatus: 'fail'
              }
            });
            return
          };
          var new_view = new FloatView({
            _u_key: action.data.id,
            _parent_u_key: action.data.parent_u_key
          });
          self._children['float-controller'].addView(new_view, {
            initTop: self._position == AppPosition.CENTER ? 105 : 60,
            initLeft: self._position == AppPosition.CENTER ? 299.5 : 170
          });
          //同一个人只显示一次头像
          var last_sender_name_tosource;
          (action.data.msgList || []).forEach(function (collect_message) {
            if (last_sender_name_tosource === collect_message.sender_name + '@' + collect_message.to_source) {
              collect_message.isSameUserWithPrevious = true;
            }
            last_sender_name_tosource = collect_message.sender_name + '@' + collect_message.to_source;
          });
          new_view.setData({
            msgList: action.data.msgList,
            title: action.data.title
          })
          break;
        case ActionType.DEL_FALSE_MSGS:
          var me = config['me']();
          var meKey = me.user_id + '@' + me.user_source;
          if (!isEmpty(action.data.messages) && action.data.messages.length) {
            falseNewsDic.deleteExistFalseMsgs(action.data.messages);
            var lastFalseMsg = falseNewsDic.gatherFalseLastMsgs(meKey);
            var tmpKeys = [];
            var tmpKeyMap = {};
            action.data.messages.forEach(function (msg) {
              if (msg.tmpKey && !tmpKeyMap[msg.tmpKey]) {
                tmpKeys.push(msg.tmpKey);
                tmpKeyMap[msg.tmpKey] = true;
              }
            });
            self._biz._delFalseMsg({
              msgs: action.data.messages
            });
            tmpKeys.forEach(function (tmpKey) {
              if (!isEmpty(lastFalseMsg)) {
                var msg_key = tmpKey.split('@@');
                if (msg_key.length) {
                  var _msg_key = msg_key[0].split('@');
                  if (_msg_key.length === 2) {
                    if (msg_key.length === 2) {
                      var shop_key = msg_key[1].split('@');
                      if (shop_key.length === 2) {
                        session.changeLastFalseMsg(_msg_key[0], Number(_msg_key[1]), shop_key[0], shop_key[1], lastFalseMsg[tmpKey]);
                      }
                    } else {
                      session.changeLastFalseMsg(_msg_key[0], Number(_msg_key[1]), lastFalseMsg[tmpKey]);
                    }
                  }
                }
              }
            });
          }
          break;
        case ActionType.DEL_MSG:
          dispatcher.dispatch({
            type: ActionType.MODAL_WIN_SHOW,
            data: {
              title: '消息提醒',
              content: "是否删除选中消息?",
              showCancel: true,
              cancelText: '取消',
              confirmText: '确定',
              success: function (res) {
                if (res.confirm) {
                  console.log('用户点击确定')
                  let msg = action.data.message;
                  if (!(msg.msg_id && (isEmpty(msg.status) || msg.status === 'SUCCESS') && non_delete_show_types.indexOf(msg.show_type) < 0)) {
                    return;
                  }
                  let sender_info = msg.sender_info;
                  let sender_id = (!isEmpty(sender_info) && isEmpty(msg.sender_id)) ? sender_info.user_id : msg.sender_id;
                  let sender_source = (!isEmpty(sender_info) && isEmpty(msg.sender_source)) ? sender_info.user_source : msg.sender_source;
                  if (msg.show_type === 'false_msg') {
                    dispatcher.dispatch({
                      type: ActionType.DEL_FALSE_MSGS,
                      data: {
                        messages: [msg]
                      }
                    });
                    return;
                  }
                  self._biz.delMsg({
                    sender_id: sender_id,
                    sender_source: sender_source,
                    msg_id: msg.msg_id,
                    to_id: msg.to_id,
                    shop_id: msg.shop_id,
                    shop_source: msg.shop_source,
                    to_source: msg.to_source
                  }, () => {
                    dispatcher.dispatch({
                      type: ActionType.TOAST_SHOW,
                      data: {
                        content: '删除成功',
                        interval: 3000
                      }
                    });
                  }, (err) => {
                    var errMsg;
                    if (err && err.error_msg) {
                      errMsg = err.error_msg
                    } else if (err === '') {
                      errMsg = '您的网络未连接，请检查后重试。';
                    } else {
                      errMsg = '删除失败，请重试';
                    }
                    if (errMsg) {
                      dispatcher.dispatch({
                        type: ActionType.TOAST_SHOW,
                        data: {
                          content: errMsg,
                          interval: 3000
                        }
                      });
                    }
                  })

                } else if (res.cancel) {
                  console.log('用户点击取消')
                }
              },
              fail: function () {

              }
            }
          });

          break;
        case ActionType.DELETE_TOGETHER:
          dispatcher.dispatch({
            type: ActionType.MODAL_WIN_SHOW,
            data: {
              title: '消息提醒',
              content: "是否删除选中消息?",
              showCancel: true,
              cancelText: '取消',
              confirmText: '确定',
              success: function (res) {
                if (res.confirm) {
                  dispatcher.dispatch({
                    type: ActionType.MULTIPLE_MENU_CLOSE
                  });
                  console.log('用户点击确定')
                  let messages = action.data.messages;
                  let msgs = [];
                  let false_msgs = [];
                  (messages || []).forEach(function (msg) {
                    if (!(msg && (msg.status === 'SUCCESS' || isEmpty(msg.status)) && non_delete_show_types.indexOf(msg.show_type) < 0)) {
                      return;
                    }
                    let sender_info = msg.sender_info;
                    let sender_id = (!isEmpty(sender_info) && isEmpty(msg.sender_id)) ? sender_info.user_id : msg.sender_id;
                    let sender_source = (!isEmpty(sender_info) && isEmpty(msg.sender_source)) ? sender_info.user_source : msg.sender_source;
                    if (msg.show_type === 'false_msg') {
                      false_msgs.push(msg);
                      return;
                    }
                    msgs.push({
                      sender_id: sender_id,
                      sender_source: sender_source,
                      msg_id: msg.msg_id,
                      to_id: msg.to_id,
                      to_source: msg.to_source
                    })
                  });
                  if (false_msgs.length) {
                    dispatcher.dispatch({
                      type: ActionType.DEL_FALSE_MSGS,
                      data: {
                        messages: false_msgs
                      }
                    });
                  }
                  if (!msgs.length) {
                    return;
                  }
                  self._biz.multipleDelMsgs({
                    messages: msgs
                  }, () => {
                    dispatcher.dispatch({
                      type: ActionType.TOAST_SHOW,
                      data: {
                        content: '删除成功',
                        interval: 3000
                      }
                    });
                  }, (err) => {
                    var errMsg;
                    if (err && err.error_msg) {
                      errMsg = err.error_msg
                    } else if (err === '') {
                      errMsg = '您的网络未连接，请检查后重试。';
                    } else {
                      errMsg = '删除失败，请重试';
                    }
                    if (errMsg) {
                      dispatcher.dispatch({
                        type: ActionType.TOAST_SHOW,
                        data: {
                          content: errMsg,
                          interval: 3000
                        }
                      });
                    }
                  });
                  dispatcher.dispatch({
                    type: ActionType.MULTIPLE_MENU_CLOSE
                  });

                } else if (res.cancel) {
                  console.log('用户点击取消')
                }
              },
              fail: function () {

              }
            }
          });

          break;
        case ActionType.STATIC_SEND_MESSAGE:
          if (!isEmpty(action.data) && action.data.text && action.data.text.length) {
            dispatcher.dispatch({
              type: ActionType.MSG_SEND_APPLY,
              data: {
                to_id: action.data.to_id,
                to_source: action.data.to_source,
                shop_id: self._currentcontact.shop_id,
                shop_source: self._currentcontact.shop_source,
                sender_id: self._currentcontact.shop_id ? self._currentcontact.shop_id : null,
                sender_source: self._currentcontact.shop_source ? self._currentcontact.shop_source : null,
                show_type: 'text',
                content: { "msg": action.data.text, "type": "text" },
                msg_type: action.data.in_group && action.data.in_group + '' === '1' ? 1005 : 2,
                at_info: ""
              }
            });
          }
          break;
        case ActionType.STATIC_LOGIN:
          config['anonymous-login'] && typeof config['anonymous-login'] === 'function' && config['anonymous-login']();
          break;
        default:
          break;
      }
    });
  })(this);

  var timer;
  // 低版本浏览器引导
  (function (self) {
    $('body').append(self.getElement());
    //支持IE7
    if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
      $(".im-app-default").hide();
      $('.im-app-ie-default').show();
    }
  })(this);

  // 同步
  (function (self) {
    asynstore.addEventListener("appStatusChange", function (data) {
      switch (data) {
        case AppStatus.MIN:
          self.minimize();
          break;
        case AppStatus.NORMAL:
          self.normalize();
          break;
        default:
          break;
      }
    });
    asynstore.addEventListener("sessionCheckChange", function (data) {
      if (!data) {
        // fixbug:https://iwork.58corp.com/v4/bug/detail/weiliao-9696
        $.each(self._children, function (key, component) {
          if (component instanceof ChatWindow) {
            component.unactive();
          }
        });
        return false;
      }
      var userKey = data;
      var shopKey;
      if (userKey.indexOf('@@') !== -1) {
        var arrs = userKey.split('@@');
        userKey = arrs[0];
        shopKey = arrs[1];
      }
      var arr = userKey.split('@');
      var user_id = arr[0];
      var user_source = arr[1];
      var shopIdArr = [];
      var param = {
        user_id: user_id,
        user_source: user_source
      };
      var isHasShopId = false;
      if (!isEmpty(shopKey)) {
        shopIdArr = shopKey.split('@');
        param.shop_id = shopIdArr[0];
        param.shop_source = shopIdArr[1];
        isHasShopId = true;
      }
      config['getUserinfo']([param], function (contactResult) {
        var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
        var contactData = contactResult[userKey];
        var contact = $.extend(true, {}, contactData);
        if (isHasShopId) {
          contact.is_shop_mode = true;
          contact.shop_id = param.shop_id;
          contact.shop_source = param.shop_source;
        }
        // 不是改用户的联系人
        // likd-a add !isAnonymousSession(contact), 匿名用户的is_contact为0， ui无法在刷新页面后切换到匿名聊天会话
        if (contact && !isAnonymousSession(contact) && contact.is_contact == 0 && contact.user_name == '' && contact.avatar == '') {
          asynstore.clearStatus('sessionKey');
          return;
        }
        // likd-a mark here, has performance bug
        session.addContactSession({
          user: contact,
          msg: null,
          currentContact: self._currentcontact
        });
        if (self._status != AppStatus.MIN || self._position == AppPosition.CENTER) {
          if (!isAnonymousSession(self._currentcontact) && isAnonymousSession(contact)) {
            var currentContactKey = self._currentcontact ? self._currentcontact.user_id + '@' + self._currentcontact.user_source : null;
            if (!isEmpty(self._currentcontact) && !isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
              currentContactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
            }
            var contactKey = contact.user_id + '@' + contact.user_source;
            if (!isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
              contactKey += '@@' + contact.shop_id + '@' + contact.shop_source;
            }
            var anonymousGroupInfo = config['anonymous_group'];
            var sessionNode = session.getSession(anonymousGroupInfo.id);
            self._children['contact-window'].gotoGroupDetail(sessionNode);
          } else if (isAnonymousSession(self._currentcontact) && !isAnonymousSession(contact)) {
            self._children['contact-window'].groupReturn();
          }
          self._switchChatWindow(contact);
        }
      });
      if (self._currentcontact) {
        var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
        if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
          contactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
        }
        if (data == contactKey) {
          return false;
        }
      }
      if (self._status == AppStatus.MIN && self._position !== AppPosition.CENTER) {
        self._setUnreadToZero(user_id, user_source, self._currentcontact);
        // falseNewsDic.falseMsgMinus(userKey);
      }
    });
  })(this);

  //键盘切换session
  (function (self) {
    var app = self.getElement();
    app.focus();
    app.keydown(function (e) {
      var keyCode = e.which;
      switch (keyCode) {
        case 38:
        case 40:
          session.tabSession(keyCode, self._currentcontact);
          break;
        default:
          break;
      }
    });
  })(this);

  (function (self) {
    $('body').on('click', function (e) {
      $(".im-qrcode-continer").hide();
      $(".im-qrcode").html('');
    })
  })(this);
};

App.prototype = Object.create(Component.prototype);
App.prototype._init = function (bizService, shopBizService) {
  var self = this;
  self._biz = bizService;
  self._shop_biz = shopBizService;
  self._allunreadcount = 0;
  self._originalTitle = window.top.document.title;
  var _isBlur = false;
  var _isMainPage = true;
  //监听是否需要把自己设置为非主页面
  var mp = new MainPage(webimActiveKey, function (isMainPage) {
    _isMainPage = isMainPage;
    if (!_isMainPage) {
      _handleNotify.call(self, mp, _isMainPage);
    }
  });
  //主页面通知其他页面自己已经是主页面
  _handleNotify.call(self, mp, true);
  //监听页面是否可见
  var pv = new PageVisible(function (visible) {
    if (visible) {
      _isMainPage = true;
      _isBlur = false;
      _handleNotify.call(self, mp, _isMainPage);
    } else {
      //此处不添加else去调起_handleNotify,是保证最好操作的IM页面，仍然是主页面，有消息Notify;
      //这个逻辑放到MainPage里面去做
      _isBlur = true;
    }
  });

  //页面被遮盖
  window.top.onblur = function () {
    setTimeout(function () {
      if (!_isMainPage) {
        if (!!self._allunreadcountTimer) {
          self._allunreadcountTimer.stop();
        }
        window.top.document.title = self._originalTitle;
      }
    }, 100);
    _isBlur = true;
  };
  window.top.onfocus = function () {
    _isBlur = false;
  };

  gdic.set('sysUser', '60687145693708@2');
  if (this._biz.options.envs === 'integrate') {
    gdic.set('sysUser', '59911917385233@2');
  }

  var me = self._biz.me();

  gdic.set('meInfo', me);

  falseNewsDic.setUser(me.user_id, me.user_source);

  this._biz.addEventListener('contactOnlineStatusChanged', function (data) {
    dispatcher.dispatch({
      type: ActionType.CONTACT_ONLINE_CHANGE,
      data: data
    });
  });

  //转人工服务ui响应
  this._biz.addEventListener('serviceTransfered', function (service) {
    var data = {
      amount: 1
    };
    dispatcher.dispatch({
      type: ActionType.UNREAD_CHANGE,
      data: data
    });
    var contact = service.session;
    if (_isMainPage) {
      var audioplayer = _getAudioPlayer.call(self);
      audioplayer.play(config['msg-sound']);
      self.titleNotify(data.amount);
      if (_isBlur) {
        self._desktopNotify('IM消息提醒', '您有' + data.amount + '条新消息！', contact);
      }
    }
    if (self._status == AppStatus.MIN) {
      self._children['contact-window'].blinkMinBar();
    }
  });

  this._biz.addEventListener('msgReceived', function (list) {
    var me = self._biz.me();
    var show_failed = [];
    $.each(list, function (index, item) {
      var user_id;
      var user_source;
      if (isGroupUser({ user_source: item.to_source })) {
        user_id = item.to_id;
        user_source = item.to_source;
      } else {
        user_id = item.sender_id;
        user_source = item.sender_source;
      }
      var contact = self._currentcontact;
      if (item.msg_list && item.msg_list.length > 0 && !isEmpty(SupportedMsgs)) {
        $.each(item.msg_list, function (msg_index, msg) {
          var show_type = msg.show_type ? msg.show_type : msg.content && msg.content.type ? msg.content.type : null;
          if (!isEmpty(show_type) && isEmpty(SupportedMsgs[show_type])) {
            show_failed.push(msg);
          }
        });
      }
      if (contact && contact.user_id == user_id && contact.user_source == user_source && item.msg_list && item.msg_list.length > 0) {
        var lastMsg = item.msg_list[0];
        var options = {
          sender_id: lastMsg.sender_id,
          sender_source: lastMsg.sender_source,
          msg_ids: [lastMsg.msg_id],
          to_id: lastMsg.to_id,
          to_source: lastMsg.to_source
        }
        self._biz.ackMsgShow(options, null, function (data) {
          // 对于店铺模式下，客服被分配走之后，无法清除未读数bug
          if (isShopModeUser(lastMsg, self._biz.me()) && data && data.error_code == 42034) {
            let options = {
              sender_id: lastMsg.sender_id,
              sender_source: lastMsg.sender_source,
              msg_id: lastMsg.msg_id,
              to_id: lastMsg.to_id,
              to_source: lastMsg.to_source
            }
            self._shop_biz && self._shop_biz.ackShown(options);
          }
        })
      }
      if (me.user_id == item.sender_id && me.user_source == item.sender_source) {
        console.log('its me');
        return;
      }

      var user_id = item.sender_id;
      var user_source = item.sender_source;
      var contact = self._currentcontact;
      if (contact && contact.user_id == user_id && contact.user_source == user_source) {
        if (self._status != AppStatus.MIN || self._position === AppPosition.CENTER) {
          if ((_isBlur || _isMinWindow() || !pv.visible()) && _isMainPage && list.length > 0) {
            self._desktopNotify('IM消息提醒', '您有' + list.length + '条新消息！', contact);
            var audioplayer = _getAudioPlayer.call(self);
            audioplayer.play(config['msg-sound']);
          }
          self._setUnreadToZero(user_id, user_source, contact);
          return;
        }
      }
    });
    if (show_failed.length) {
      self._biz.reportMessages({
        show_failed: show_failed
      });
    }
  });


  this._biz.addEventListener('otherReadUpdate', function (data) {
    // 更新已读未读状态
    /*     $.each(data, function (idx, item) {
          $.each(item.other_data, function (idx, item) {
            var userKey = item.other_id + '@' + item.other_source;
            gdic.set('otherRead-' + userKey, item.other_last_showed_msg_id);
          })
        })
        var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
        var ct = self._children[contactKey];
        !!ct && ct.otherReadUpdate(); */
  })

  this._biz.addEventListener('updateEvent', function(data) {
    debugger
    console.log(data)
  })

  this._biz.addEventListener('contactInfoChanged', function (contactInfo) {
    if (!self._currentcontact || !contactInfo || contactInfo.length == 0) {
      return;
    }
    for (var i = 0; i < contactInfo.length; i++) {
      var contact = contactInfo[i];
      if (self._currentcontact.user_id + '@' + self._currentcontact.user_source == contact.user_id + '@' + contact.user_source) {
        self._currentcontact = contact;
        var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
        if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
          contactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
        }
        if (!isEmpty(self._currentcontact.group_info)) {
          _groupCurrentCount[contactKey] = self._currentcontact.group_info.current_count;
        }
        if (!isGroupUser(contact)) {
          return;
        }
        var ct = self._children[contactKey];
        !!ct && ct.setContact(self._currentcontact);
      }
    }
  })

  this._biz.addEventListener('cometReceived', function (cometData) {
    // 接收到的所有长链接指令
    // 输入通道指令解析
    if (cometData && cometData.data) {
      var dataList = cometData.data;
      for (var i = 0; i < dataList.length; i++) {
        var item = dataList[i];
        var type = item.valueType;
        var itemVal = item.value;
        if (isEmpty(itemVal)) {
          return;
        }
        for (var j = 0; j < itemVal.length; j++) {
          var content = item.value[j].content;
          if (typeof content == 'string') {
            content = jsonHandler.parse(content);
          }
          switch (type) {
            case 'commandmsg':
              if (content.name == 'UPDATEEVENT' && content.event_type == 'BEINPUTTING') {
                dispatcher.dispatch({
                  type: ActionType.TOAST_SHOW,
                  data: {
                    content: '用户' + content.from_id + '@' + content.from_source + '正在输入中....',
                    interval: 3000
                  }
                });
              } else if (content.name == 'OUTGROUPNOTICE') {
                var gKey = content.data && content.data.g_id + '@' + content.data.g_source;
                var delSessionKey = localStorage.getItem("delSessionKey") ? localStorage.getItem("delSessionKey") + ',' + gKey : gKey;
                localStorage.setItem("delSessionKey", JSON.stringify(delSessionKey));
              }
              break;
            default:
              break;
          }
        }
      }
      console.log('cometData', cometData);
    }
  })

  // 会话列表和未读数量发生改变以后触发
  var handlechange = function () {
    var sessions = self._biz.getAllSessions();
    console.log('handlechange', sessions.length);
    if (sessions.length == 0) {
      session.addContactSessions([]);
      session.removeChecked();
      // likd-a mark here, clear sessionKey ???
      asynstore.clearStatus('sessionKey');
      $.each(self._children, function (key, component) {
        if (component instanceof ChatWindow) {
          component.unactive();
        }
      });
      self._children['contact-window'].addVoidBackground(true);
      return;
    }
    var unreadamount = self._biz.getAllUnreadAmount();
    var me = self._biz.me();
    var list = [{
      user_id: me.user_id,
      user_source: me.user_source
    }];
    var currentKey = me.user_id + "@" + me.user_source;
    var currentcontact = self._currentcontact;
    // 外部sessions处理，如将各别会话置顶
    config['sessions-converter'](sessions, function (sessions) {
      $.each(sessions, function (index, session) {
        var userKey = session.user.user_id + '@' + session.user.user_source;
        if (userKey == currentKey) {
          return;
        }
        list.push(session.user);
      });
      config['getUserinfo'](list, function (contacts) {
        var fullsessions = [];
        var anonymousSessions = [];
        $.each(sessions, function (index, item) {
          var user_id = item.user.user_id;
          var user_source = item.user.user_source;
          var userkey = user_id + '@' + user_source;
          var unreadkey = userkey;
          var shopKey;
          if (item.user && item.user.shop_id && item.user.shop_source) {
            shopKey = item.user.shop_id + '@' + item.user.shop_source;
            unreadkey += '@@' + shopKey;
            userkey += '@@' + shopKey;
            item.user.shop_user_info = contacts[shopKey]
          }
          var user = $.extend(true, {}, contacts[userkey], item.contact, item.user);
          if (!isEmpty(shopKey) || isEmpty(user.msg_set)) {
            user.msg_set = { ses_top: 0, silent: 0 };
          }
          if (!isEmpty(item.user.update_time)) {
            user.msg_set.ses_top = !isEmpty(item.user.ses_top) ? item.user.ses_top : !isEmpty(user.msg_set.ses_top) ? user.msg_set.ses_top : null;
            user.msg_set.silent = !isEmpty(item.user.silent) ? item.user.silent : !isEmpty(user.msg_set.silent) ? user.msg_set.silent : null;
            user.update_time = item.user.update_time;
            var sesTopText = user.msg_set.ses_top == 1 ? '取消置顶' : '置顶';
            var silentText = user.msg_set.silent == 1 ? '取消免打扰' : '免打扰';
            if (self._children[unreadkey]) {
              self._children[unreadkey].updateHandleText(sesTopText);
              self._children[unreadkey].updateHandleText(silentText);
            }
          }
          var msg = item.msg ? $.extend({}, item.msg) : null;
          item.unread_show_type = user.msg_set && user.msg_set.silent == 1 ? 'rash' : '';
          var unread = unreadamount[unreadkey] || 0;
          var currentcontactKey = currentcontact ? currentcontact.user_id + '@' + currentcontact.user_source : null;
          if (currentcontactKey && currentcontact.shop_id && currentcontact.shop_source) {
            currentcontactKey += '@@' + currentcontact.shop_id + '@' + currentcontact.shop_source
          }
          if (currentcontactKey == unreadkey) {
            if (self._position === AppPosition.CENTER || self._status != AppStatus.MIN) {
              unread = 0;
              // 标记已读
              self._setUnreadToZero(user_id, user_source, currentcontact);
            }
          }
          if (user) {
            if (!isEmpty(msg) && (currentKey != msg.sender_id + '@' + msg.sender_source) && !isEmpty(user.remark) && !isEmpty(user.remark.remark_name)) {
              if (!isEmpty(msg.content.operator) && !isEmpty(msg.replace) && !isEmpty(msg.replace.content) && !isEmpty(msg.replace.content._replaceMsg) && !isEmpty(msg.content.operator.pos_start) && !isEmpty(msg.content.operator.pos_end)) {
                msg.content.text = msg.content.msg = msg.replace.content._replaceMsg.substring(0, msg.content.operator.pos_start) + user.remark.remark_name + msg.replace.content._replaceMsg.substring(msg.content.operator.pos_end);
              } else if (!isEmpty(msg.content.operator) && !isEmpty(msg.content._replaceMsg) && !isEmpty(msg.content.operator) && !isEmpty(msg.content.operator.pos_start) && !isEmpty(msg.content.operator.pos_end)) {
                msg.content.msg = msg.content._replaceMsg.substring(0, msg.content.operator.pos_start) + user.remark.remark_name + msg.content._replaceMsg.substring(msg.content.operator.pos_end);
              }
            }
            var session = {
              user: user,
              unread: unread,
              msg: msg,
              sort_time: item.sort_time,
              unread_show_type: item.unread_show_type,
              is_top_group: !!item.is_top_group,   // 是否属于置顶区块
              is_anonymous_user: isAnonymousSession(user)   // 是否为匿名用户
            };
            // 匿名用户
            //if (!(session.is_anonymous_user && me.is_anonymous_login)) {
            if (session.is_anonymous_user) {
              anonymousSessions.push(session);
            } else {
              fullsessions.push(session);
            }
            //}
          }
          else {
            console.warn('没有找到userinfo.', userkey)
          }
        });
        // console.log('fullsessions', fullsessions);
        // 合并匿名会话
        if (anonymousSessions.length > 0) {//&& !me.is_anonymous_login) {
          var anonymousGroupInfo = config['anonymous_group'];
          //debugger;
          self.addSessionGroup(anonymousGroupInfo);
          // session.addContactSessions(anonymousSessions);
          // let anoymouseSessionKeys = [];
          // anonymousSessions.map((sessionItem, index) => {
          //   anoymouseSessionKeys.push({
          //     user_id: sessionItem.user.user_id,
          //     user_source: sessionItem.user.user_source
          //   });
          // });
          // session.setContactToGroup({
          //   sessions: anoymouseSessionKeys,
          //   clear: true
          // }, anonymousGroupInfo.id)
          session.addContactGroupSessions(anonymousSessions, anonymousGroupInfo.id);
        } else {
          //if (!me.is_anonymous_login) {
          var anonymousGroupInfo = config['anonymous_group'];
          session.addContactGroupSessions([], anonymousGroupInfo.id);
          //}
        }
        // fullsessions.unshift({
        //   user: {
        //     attention: 0,
        //     avatar: "//pic3.58cdn.com.cn/nowater/webim/big/n_v2408f88bec7c24283ab5a3ac208964ad0.png",
        //     contact_extension: "",
        //     device_id: "",
        //     gender: 0,
        //     group_info: {},
        //     in_black_list: 0,
        //     in_group: 0,
        //     is_blacked: 0,
        //     is_contact: 0,
        //     is_group: false,
        //     is_ics_user: true,
        //     msg_set: {
        //       ses_top: 0,
        //       silent: 0
        //     },
        //     name_spell: "Bang Bang Zhi Neng Ke Fu",
        //     register: 1,
        //     remark: {},
        //     session_attribute: "",
        //     shop_info: null,
        //     star: 0,
        //     user_extension: "{}",
        //     user_id: "txfw10000",
        //     user_name: "提醒服务",
        //     user_source: 108,
        //     user_type: "0"
        //   },
        //   unread: 0,
        //   msg: null,
        //   sort_time: new Date().getTime(),
        //   unread_show_type: '',
        //   is_top_group: true,   // 是否属于置顶区块
        // })
        session.addContactSessions(fullsessions);
      });
    });
  };

  // 文件、视频审核结果通知
  this._biz.addEventListener('uploadauditChange', function (data) {
    if (!data || data.ret + '' !== '0' || !data.wos_file_name) {
      return;
    }
    dispatcher.dispatch({
      type: ActionType.UPLOAD_AUDIT_CHANGE,
      data: data
    });
  });

  this._biz.addEventListener('sessionChanged', function (sessions) {
    // console.log('session changed.', sessions);
    handlechange();
  });

  this._biz.addEventListener('sessionPortChanged', function (sessions) {
    //console.log(sessions);
  });

  this._biz.addEventListener('unreadChanged', function (unreadamount) {
    handlechange();
  });

  this._biz.addEventListener('syncAppData', function (data) {
    dispatcher.dispatch({
      type: ActionType.MSG_SYNC,
      data: data
    });
  });

  this._biz.addEventListener('login', function () {
    var delSessionKey = JSON.parse(localStorage.getItem("delSessionKey"));
    var sessionKey = JSON.parse(localStorage.getItem("sessionKey"));
    if (!isEmpty(delSessionKey) && delSessionKey.indexOf(sessionKey) != -1) {
      asynstore.clearStatus('sessionKey');
    }
    asynstore.start();
  });

  this._biz.addEventListener('logout', function () {

  });
  this._biz.addEventListener('loginUserChanged', function () {
    asynstore.clearStatus('sessionKey');
  });

  console.time('main page');

  this._biz.addEventListener('mainPageChanged', function () {
    console.timeEnd('main page');
    //主页面闪烁未读消息数
    if (!!self._allunreadcount && _isMainPage) {
      self.titleNotify(self._allunreadcount);
    }
  });

  // 页面假消息存储
  this._biz.addEventListener('falseNews', function (tmpMsgs) {
    var client_msgs = [];
    for (var msgs_key in tmpMsgs) {
      if (tmpMsgs[msgs_key] && tmpMsgs[msgs_key].length) {
        var falseMsg;
        var falseMsgs_push = [];
        var _msg_key = msgs_key.split('@');
        var shop_key = msgs_key.split('@@');
        var shop_id;
        var shop_source;
        if (shop_key.length === 2) {
          shop_key = shop_key[1];
          if (shop_key) {
            shop_key = shop_key.split('@');
            shop_id = shop_key[0];
            shop_source = shop_key[1];
          }
        }
        $.each(tmpMsgs[msgs_key], function (key, val) {
          var tmpkey = 'tmpMsg-' + msgs_key;
          if (!isEmpty(val) && val.is_false_new) {
            var _session;
            if (shop_id && shop_source) {
              _session = session.getSession(_msg_key[0], Number(_msg_key[1]), {
                shop_id: shop_id,
                shop_source: shop_source
              });
            } else {
              _session = session.getSession(_msg_key[0], Number(_msg_key[1]));
            }
            if (!isEmpty(_session) && _session.msg) {
              var tmpMsgId = sumBigNumber(_session.msg.msg_id, '1');
              var follow_msg_id = _session.msg.msg_id;
              var lastFalseMsgs = falseNewsDic.gatherExistFalseMsgs(msgs_key, _session.msg.msg_id);
              if (lastFalseMsgs && lastFalseMsgs.length) {
                if (lastFalseMsgs[lastFalseMsgs.length - 1].msg_id && strToNumCompare(lastFalseMsgs[lastFalseMsgs.length - 1].msg_id, _session.msg.msg_id) > 0) {
                  tmpMsgId = sumBigNumber(lastFalseMsgs[lastFalseMsgs.length - 1].msg_id, '1');
                  follow_msg_id = lastFalseMsgs[lastFalseMsgs.length - 1].msg_id;
                }
              }
              falseMsg = $.extend({
                msg_id: tmpMsgId
              }, val);
              falseMsg.tmpKey = msgs_key,
                falseMsg.follow_msg_id = follow_msg_id;
              falseMsg.is_saved = true;
              falseNewsDic.saveExistFalseMsgs(falseMsg, msgs_key);
              falseMsgs_push.push(falseMsg);
              // if (falseMsg.not_answered) {
              //   if (!isEmpty(self._currentcontact)) {
              //     var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
              //     if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
              //       contactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
              //     }
              //     if (contactKey != falseMsg.tmpKey) {
              //       falseNewsDic.falseMsgPlus(falseMsg.tmpKey, falseMsg.msg_id);
              //     }
              //   }
              // }
              val = falseMsg;
            }
          }
          if (gdic.get(tmpkey) instanceof Array) {
            var tmpFalseMsgs = gdic.get(tmpkey);
            tmpFalseMsgs.push(val);
            gdic.set(tmpkey, tmpFalseMsgs);
          } else {
            gdic.set(tmpkey, [val]);
          }
        });
        falseNewsDic.set(falseMsgs_push);
        if (!isEmpty(falseMsg)) {
          gdic.set('tmpMsg-session-' + msgs_key, falseMsg);
          if (shop_id && shop_source) {
            session.changeLastFalseMsg(_msg_key[0], Number(_msg_key[1]), shop_id, shop_source, falseMsg);
          } else {
            session.changeLastFalseMsg(_msg_key[0], Number(_msg_key[1]), falseMsg);
          }
        }
        client_msgs = client_msgs.concat(tmpMsgs[msgs_key]);
      }
    }
    self._biz.reportMessages({
      client_msgs: client_msgs
    });
  });

  // 匿名聊天对象登录
  this._biz.addEventListener('anonymousContactLogined', function (data) {
    let newContact;
    if (data && data.contact && data.newContact) {
      newContact = data.newContact;
      contact = data.contact;
      let currentContactKey = self._currentcontact ? self._currentcontact.user_id + '@' + self._currentcontact.user_source : null;
      if (!isEmpty(self._currentcontact) && !isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
        currentContactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
      }
      let contactKey = contact.user_id + '@' + contact.user_source;
      if (!isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
        contactKey += '@@' + contact.shop_id + '@' + contact.shop_source;
      }
      let newContactKey = newContact.user_id + '@' + newContact.user_source;
      if (!isEmpty(newContact.shop_id) && !isEmpty(newContact.shop_source)) {
        newContactKey += '@@' + newContact.shop_id + '@' + newContact.shop_source;
      }
      let me = self._biz.me();
      let meKey = me.user_id + '@' + me.user_source;
      if (newContactKey === meKey) {
        asynstore.stop();
        self.removeChatwindow(contact);
        self._biz.delAnonymousSessions([{
          ...data.contact
        }]);
        self._currentcontact = null;
        session.removeChecked();
        asynstore.clearStatus('sessionKey');
        asynstore.start();
        // 对于匿名合并为实名的情况下，需要重新拉取会话列表(之前拉取的会话列表可能不完整)
        self._biz.reloadSessions({}, function () {
          self._biz.resetLoadedMsg();
          self._biz.resetLoadedUser();
          self._biz.resetLoadedGroupInfo();
        })
      } else if (isEmpty(self._currentcontact)) {
        self.removeChatwindow(newContact);
        self._biz.delAnonymousSessions([{
          ...data.contact
        }]);
        // 若被合并的匿名会话正好在其他页面点开的状态下，匿名会出现在一级目录下(https://iwork.58corp.com/v4/bug/detail/weiliao-9696)
        if (asynstore._sessionkey && asynstore._sessionkey == contactKey) {
          asynstore.stop();
          asynstore.clearStatus('sessionKey');
          asynstore.start();
        }
      } else if (newContactKey === currentContactKey) {
        asynstore.stop();
        self.removeChatwindow(newContact);
        self._gotoContact(newContact);
        self._biz.delAnonymousSessions([{
          ...data.contact
        }]);
        asynstore.start();
      } else if (contactKey === currentContactKey) {
        dispatcher.dispatch({
          type: ActionType.MODAL_WIN_SHOW,
          data: {
            title: '',
            content: "该游客已经成功登录，点击与登录后的用户继续聊",
            showCancel: false,
            confirmText: '点击跳转',
            success: function (res) {
              if (res.confirm) {
                if (!isEmpty(newContact)) {
                  asynstore.stop();
                  self.removeChatwindow(newContact);
                  //self._gotoContact(newContact);
                  self._biz.delAnonymousSessions([{
                    ...data.contact
                  }]);
                  //self._currentcontact = data.contact;
                  session.setChecked(newContact.user_id, newContact.user_source, newContact);
                  asynstore.setSession(newContact);
                  asynstore.start();
                } else {
                  //self._currentcontact = null;
                }
              } else if (res.cancel) {

              }
            },
            fail: function () {

            }
          }
        });
      } else {
        self.removeChatwindow(newContact);
        self._biz.delAnonymousSessions([{
          ...data.contact
        }]);
      }
    } else {
      return;
    }
  });

  // this._biz.addEventListener('referChanged', function (referObj) {
  //   var refer = referObj.refer;
  //   if (!refer || !refer.invitation)
  //     return;
  // });

  this._biz.start();

  session.addEventListener('selfchanged', function (node) {
    if (!node.group && !node.contact)
      return;
    dispatcher.dispatch({
      type: ActionType.SESSION_SELF_CHANGE,
      data: node
    });
    var contact = node.contact || node.group;
    if (!isGroupUser(contact)) {
      if (isShopModeUser(contact)) {
        return;
      } else if (!isEmpty(contact.remark)) {
        var key = contact.user_id + '@' + contact.user_source;
        var ct = self._children[key];
        if (!!ct && !isEmpty(ct._contact) && !isEmpty(ct._contact.remark) && ct._contact.remark.remark_name !== contact.remark.remark_name) {
          !!ct && ct.setContact(contact);
        }
        return;
      }
    }
    var key = node.group ? 'group-' + contact.id : contact.user_id + '@' + contact.user_source;
    if (_groupCurrentCount && _groupCurrentCount[key] && _groupCurrentCount[key] > contact.group_info.current_count) {
      contact.group_info.current_count = _groupCurrentCount[key];
    }
    var content = node.msg && node.msg.content;
    switch (content && content.op_type) {
      case 'change_group_name':
        var keyText = '更改群名称为：';
        contact.user_name = content.default_text && (content.default_text).indexOf(keyText) !== -1 ? content.default_text.split(keyText)[1] : contact.user_name;
        break;
      default:
        break;
    }
    var ct = self._children[key];
    !!ct && ct.setContact(contact);
  });

  session.addEventListener('childrenchanged', function (node) {
    // console.log('childrenchanged', node.children);
    dispatcher.dispatch({
      type: ActionType.SESSION_CHILDREN_CHANGE,
      data: node
    });
  });

  session.addEventListener('totalUnreadChanged', function (data) {
    var amountIncreased = self._allunreadcount < data.amount;
    self._allunreadcount = data.amount;
    dispatcher.dispatch({
      type: ActionType.UNREAD_CHANGE,
      data: data
    });
    if (data.amount <= 0) {
      self._children['contact-window'].resetblinkMinBar();
      window.top.document.title = self._originalTitle;
      if (!!self._allunreadcountTimer) {
        self._allunreadcountTimer.stop();
      }
      return;
    }
    var contact = data.lastsession;
    if (_isMainPage) {
      if (amountIncreased) {
        var audioplayer = _getAudioPlayer.call(self);
        audioplayer.play(config['msg-sound']);
      }
      self.titleNotify(data.amount);
      if (_isBlur) {
        self._desktopNotify('IM消息提醒', '您有' + data.amount + '条新消息！', contact);
      }
    }
    if (self._status == AppStatus.MIN) {
      self._children['contact-window'].blinkMinBar();
    }
  });

  session.addEventListener('tabSession', function (contact) {
    self._gotoContact(contact);
  });


  // 统计初始化
  // 外部是否需要统计埋点
  if (!!config['stat'].appid && !!config['stat'].appkey) {
    stat.init(config['stat']);
  }

  var meId = this._biz.options.user_id;
  var md5Key = '61e2e9e0d3e683bdfb96b66f60a07f31';
  var monitor = Monitor.getInstance({
    projectID: 'IM_PC',
    userId: meId ? hex_md5(hex_md5(meId) + md5Key) : ''
  });
  monitor.errorReport();
  monitor.performanceReport();

  self.bindRTCEmitter && self.bindRTCEmitter();
};
App.prototype.chatTo = function (user_id, user_source, cb, shop_id, shop_source) {
  var me = this._biz.me();
  this.normalize();
  if (!me)
    return;
  if (me.user_id == user_id && me.user_source == user_source)
    return;

  var self = this;
  var param = {
    user_id: user_id,
    user_source: user_source
  }
  var isHasShopId = false;
  if (!isEmpty(shop_id) && !isEmpty(shop_source)) {
    param.shop_id = shop_id;
    param.shop_source = shop_source;
    isHasShopId = true;
  }
  config['getUserinfo']([param], function (contactResult) {
    var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
    var contact = contactResult[userKey];
    if (isHasShopId) {
      contact.shop_id = param.shop_id;
      contact.shop_source = param.shop_source;
    }

    if (contact) {
      // if (contact.register === 0 && me && me.is_anonymous_login) {
      //   return;
      // }
      if (!self._biz.getSession(user_id, user_source)) {
        self._biz.addSession({
          user: {
            user_id: contact.user_id,
            user_source: contact.user_source
          },
          msg: null
        });
        session.addContact(contact);
      }
      self._switchChatWindow(contact);
      if (cb)
        cb();
    }
  });
};
App.prototype.addSessionGroup = function (group) {
  session.addGroup(group);
};
App.prototype.setContactToGroup = function (user_id, user_source, group_id, shop_id, shop_source) {
  var self = this;
  var param = {
    user_id: user_id,
    user_source: user_source
  }
  var isHasShopId = false;
  if (!isEmpty(shop_id) && !isEmpty(shop_source)) {
    param.shop_id = shop_id;
    param.shop_source = shop_source;
    isHasShopId = true;
  }
  config['getUserinfo']([param], function (contactResult) {
    var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
    var contact = contactResult[userKey];
    if (isHasShopId) {
      contact.shop_id = param.shop_id;
      contact.shop_source = param.shop_source;
    }
    if (contact) {
      session.addContact(contact);
      session.setContactToGroup(contact.user_id, contact.user_source, group_id);
    }
  });
};
App.prototype.normalize = function () {
  this._children['contact-window'].resetblinkMinBar();
  if (this._status === AppStatus.NORMAL || this._position === AppPosition.CENTER)
    return;
  /*if (_isFirstNormal) {
   this._children['contact-window'].addMoreSession();
   _isFirstNormal = false;
   }*/
  this._status = AppStatus.NORMAL;
  asynstore.setAppStatus(this._status);
  this.setData({
    status: AppStatus.NORMAL
  });
  dispatcher.dispatch({
    type: ActionType.APP_STATUS_CHANGE,
    data: AppStatus.NORMAL
  });
  this.triggerEvent('appstatusChanged', AppStatus.NORMAL);
  this.triggerEvent('iframePosChanged', 'NORMAL', config['normal-iframe-position']);
  // 由最小化恢复窗口时，将当前联系人的未读消息置为零,滚动到消息底部
  if (this._currentcontact) {
    this._gotoContact(this._currentcontact);
  }
  // 打开查询会话状态定时器
  this._biz.startOnlineTimer();
  //埋点统计（展开按钮点击）
  //stat.report(StatPoint.normal_btn_click);
  if (window.WMDA_REPORT) {
    window.WMDA_REPORT('custom', { event_id: '14' })
  }
};
App.prototype.minimize = function () {
  if (this._status === AppStatus.MIN || this._position === AppPosition.CENTER)
    return;
  var self = this;
  this._status = AppStatus.MIN;
  asynstore.setAppStatus(this._status);
  this.setData({
    status: AppStatus.MIN
  });
  dispatcher.dispatch({
    type: ActionType.APP_STATUS_CHANGE,
    data: AppStatus.MIN
  });
  self.triggerEvent('iframePosChanged', 'MIN', {
    bottom: 0,
    right: 0
  });
  setTimeout(function () {
    if (self._status === AppStatus.MIN)
      self.triggerEvent('appstatusChanged', AppStatus.MIN);
  }, 250);
  //埋点统计（最小化点击）
  //stat.report(StatPoint.min_btn_click);
  if (window.WMDA_REPORT) {
    window.WMDA_REPORT('custom', { event_id: '9' })
  }
  // 关闭查询会话状态定时器
  this._biz.stopOnlineTimer();
  // 存在未读数量时，闪烁
  if (this._allunreadcount > 0) {
    this._children['contact-window'].blinkMinBar();
  }
};
App.prototype.position = function (position) {
  position = position.toUpperCase();
  if (this._position === position)
    return;

  this._position = position;
  this.setData({
    position: position
  });
  // 全屏状态开启查询在线状态定时器
  if (this._position === AppPosition.CENTER) {
    // 打开查询会话状态定时器
    this._biz.startOnlineTimer();
    /*// 会话列表展现
     this._children['contact-window'].addMoreSession();*/
  }
  gdic.set('position', this._position);
};
App.prototype.render = function () {
  if (this._data.status === AppStatus.NORMAL) {
    this._element.removeClass('im-min');
  } else {
    this._element.addClass('im-min');
  }
  // likd-a mark here , for fixing https://iwork.58corp.com/v4/bug/detail/weiliao-9500
  // this._element.click(function(e){
  //   e.stopPropagation();
  // });
  this._element.removeClass('im-center im-rightbottom');
  switch (this._data.position) {
    case AppPosition.CENTER:
      this._element.addClass('im-center');
      $('<div>').addClass('im-center-bg').appendTo($('body'));
      break;
    case AppPosition.RIGHT_BOTTOM:
      this._element.addClass('im-rightbottom');
      break;
    default:
      $('.im-center-bg').remove();
      break;
  }
};
App.prototype.titleNotify = function (allunreadcount, txt) {
  var self = this;
  var win = window.top;
  if (!!self._allunreadcountTimer) {
    self._allunreadcountTimer.stop();
  }
  if (!!allunreadcount && allunreadcount > 0) {
    (function () {
      var step = 0;
      self._allunreadcountTimer = new Timer({
        onElapsed: function (cb) {
          step++;
          if (step % 2 == 1) {
            win.document.title = "【" + allunreadcount + "条新消息】";
          }
          if (step % 2 == 0) {
            win.document.title = "【　　　 　        】";
          }
          cb();
        },
        duration: 1000
      });
    })();
    self._allunreadcountTimer.start();
  } else if (txt) {
    (function () {
      var step = 0;
      self._titleTimer = new Timer({
        onElapsed: function (cb) {
          step++;
          if (step % 2 == 1) {
            win.document.title = txt;
          }
          if (step % 2 == 0) {
            win.document.title = "【　　　 　        　　　 　        】";
          }
          cb();
        },
        duration: 1000
      });
    })();
    self._titleTimer.start();
  }
  else {
    win.document.title = self._originalTitle;
    if (!!self._allunreadcountTimer) {
      self._allunreadcountTimer.stop();
    }
    if (!!self._titleTimer) {
      self._titleTimer.stop();
    }

  }
};
App.prototype._desktopNotify = function (title, content, contact) {
  var self = this;
  var win = window.top;
  if (!title && !content) {
    title = "IM提醒";
    content = "您有新消息啦！";
  }
  var iconUrl = "//pic3.58cdn.com.cn/webim/big/n_v1bkujjdzjwyvfqyxyq4ja.png?h=200&w=200&crop=1";
  var Notification = win.Notification || win.mozNotification || win.webkitNotification;
  if (Notification) {
    Notification.requestPermission(function (status) {
      //status默认值'default'等同于拒绝 'denied' 意味着用户不想要通知 'granted' 意味着用户同意启用通知
      if ("granted" != status) {
        return;
      } else {
        var notify = new Notification(
          title,
          {
            tag: 'IM',//实例化的notification的id
            icon: iconUrl,//通知的缩略图,//icon 支持ico、png、jpg、jpeg格式
            body: content //通知的具体内容
          }
        );
        self._notify = notify;
        notify.onclick = function () {
          //如果通知消息被点击,通知窗口将被激活
          win.focus();
          //对于iframe内部，window.top.focus不起作用通过事件监听实现
          self.triggerEvent('windowFocus');
          notify.close();
          self.normalize();
          self._gotoContact(contact);
          // 埋点统计，桌面提醒点击事件
          //stat.report(StatPoint.desktop_notify_click);
          if (window.WMDA_REPORT) {
            window.WMDA_REPORT('custom', { event_id: '6' })
          }
        };
        notify.onerror = function () {
          console.log("HTML5桌面消息出错！！！");
        };
        notify.onshow = function () {
          setTimeout(function () {
            notify.close();
          }, 5000)
        };
        notify.onclose = function () {
          console.log("HTML5桌面消息关闭！！！");
        };
      }
    });
  } else {
    console.log("您的浏览器不支持桌面消息");
  }
};
App.prototype._findChatWindow = function (contact) {
  if (!contact) {
    return null;
  }
  var self = this;
  var key = contact.user_id + '@' + contact.user_source;
  if (isShopModeUser(contact) && !isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
    key += '@@' + contact.shop_id + '@' + contact.shop_source;
  }
  var ct = self._children[key];
  return ct;
}
App.prototype._getChatWindow = function (contact) {
  if (!contact) {
    return null;
  }
  var self = this;
  var opts = {
    user_id: contact.user_id,
    user_source: contact.user_source
  };
  var key = contact.user_id + '@' + contact.user_source;
  let isShopContact = false;
  if (isShopModeUser(contact) && !isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
    isShopContact = true;
    key += '@@' + contact.shop_id + '@' + contact.shop_source;
    opts.shop_id = contact.shop_id;
    opts.shop_source = contact.shop_source;
    opts.is_shop_mode = true;
  }
  var ct = self._children[key];
  if (!ct) {
    let me = self._biz.me();
    ct = new ChatWindow({
      _anonymousLogined: me.is_anonymous_login,
      getFreshMsgRecords: function (opts, cb) {
        // 新消息推送可能会存在先退msg_id大的，再推msg_id小的, 所以这里除了比last_msg_id大的数据以外，还查询比msg_id小的数据
        var onQueryCompleted = (function () {
          var result = [];
          var count = 0;
          return function (msgs) {
            result = result.concat(msgs);
            if (++count === 2) {
              result.sort(function (a, b) {
                return strToNumCompare(a.msg_id, b.msg_id) < 0 ? -1 : 1;
              });
              cb(result);
            }
          };
        })();

        // 查询比last_msg_id大的count条
        _getMsgRecords.call(self, {
          user_id: opts.user_id,
          user_source: opts.user_source,
          msg_id: opts.last_msg_id,
          count: opts.count,
          shop_id: opts.shop_id,
          shop_source: opts.shop_source,
          option: 1
        }, function (msgs, otherLastShowedMsgId) {
          onQueryCompleted(msgs);
          if (!isEmpty(otherLastShowedMsgId)) {
            var userKey = opts.user_id + '@' + opts.user_source;
            if (!isEmpty(opts.shop_id) && !isEmpty(opts.shop_source)) {
              userKey += '@@' + opts.shop_id + '@' + opts.shop_source;
            }
            if (gdic.get('otherRead-' + userKey) !== otherLastShowedMsgId) {
              gdic.set('otherRead-' + userKey, otherLastShowedMsgId);
              var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
              if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
                contactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
              }
              var ct = self._children[contactKey];
              !!ct && ct.otherReadUpdate();
            }
          }
          if (msgs.length == 0) {
            return;
          }
          var param = {
            user_id: opts.user_id,
            user_source: opts.user_source
          }
          var isHasShopId = false;
          if (!isEmpty(opts.shop_id) && !isEmpty(opts.shop_source)) {
            param.shop_id = opts.shop_id;
            param.shop_source = opts.shop_source;
            isHasShopId = true;
          }
          config['getUserinfo']([param], function (contactResult) {
            var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
            var contact = contactResult[userKey];
            if (isHasShopId) {
              contact.shop_id = param.shop_id;
              contact.shop_source = param.shop_source;
              contact.is_shop_mode = true;
            }
            if (contact) {
              self._currentcontact = contact;
              var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
              if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
                contactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
              }
              if (!isEmpty(self._currentcontact.group_info)) {
                _groupCurrentCount[contactKey] = self._currentcontact.group_info.current_count;
              }
              var ct = self._children[contactKey];
              !!ct && ct.setContact(self._currentcontact);
            }
          });

        }, function (error) {
          onQueryCompleted([]);
        });

        // 查询比last_msg_id小的3条(服务端已经实现不同端消息同步，不需要再做)
        _getMsgRecords.call(self, {
          user_id: opts.user_id,
          user_source: opts.user_source,
          msg_id: opts.last_msg_id,
          shop_id: opts.shop_id,
          shop_source: opts.shop_source,
          count: 3,
          option: -1,
          localonly: true
        }, function (msgs) {
          // 判断是否为连续的消息(c端匿名实名账号合并之后，b端历史记录可能出现问题)
          // fixbug :https://iwork.58corp.com/v4/bug/detail/weiliao-9680
          if (msgs.length > 0) {
            msgs.sort(function (a, b) {
              return strToNumCompare(a.msg_id, b.msg_id) < 0 ? 1 : -1;
            });
            if (!isEmpty(opts.last_msg) && !isEmpty(opts.last_msg.link_msg_id) && !isEmpty(msgs[0].msg_id) && strToNumCompare(opts.last_msg.link_msg_id, msgs[0].msg_id) != 0) {
              msgs = [];
            } else {
              //fixbug:https://iwork.58corp.com/v4/bug/detail/weiliao-9530
              for (let i = 0; i < msgs.length; i++) {
                if (!isEmpty(msgs[i].link_msg_id) && !isEmpty(msgs[i + 1]) && !isEmpty(msgs[i + 1].msg_id) && strToNumCompare(msgs[i].link_msg_id, msgs[i + 1].msg_id) != 0) {
                  msgs.splice(i + 1);
                }
              }
            }
          }
          onQueryCompleted(msgs);
          if (msgs.length == 0) {
            return;
          }
        }, function (error) {
          onQueryCompleted([]);
        });
      },
      getOldMsgRecords: function (opts, cb, fail) {
        _getMsgRecords.call(self, {
          user_id: opts.user_id,
          user_source: opts.user_source,
          msg_id: opts.last_msg_id,
          count: opts.count,
          shop_id: opts.shop_id,
          shop_source: opts.shop_source,
          option: -1,
          is_get_from_api: true
        }, function (msgs, otherLastwedMsgId, min_msg_id) {
          var groupKey;
          if (isGroupUser({ user_source: opts.user_source })) {
            groupKey = opts.user_id + '@' + opts.user_source;
            _loadedGroupMsgsObj[groupKey] = !isEmpty(_loadedGroupMsgsObj[groupKey]) ? _loadedGroupMsgsObj[groupKey] : {};
          }
          if (!isEmpty(msgs) && msgs.length) {
            var show_failed = [];
            $.each(msgs, function (index, msg) {
              var show_type = msg.show_type ? msg.show_type : msg.content && msg.content.type ? msg.content.type : null;
              if (!isEmpty(show_type) && isEmpty(SupportedMsgs[show_type])) {
                show_failed.push(msg);
              }
              if (groupKey) {
                var senderKey = msg.sender_id + '@' + msg.sender_source;
                _loadedGroupMsgsObj[groupKey][senderKey] = !isEmpty(_loadedGroupMsgsObj[groupKey][senderKey]) ? _loadedGroupMsgsObj[groupKey][senderKey] : [];
                _loadedGroupMsgsObj[groupKey][senderKey].push(msg);
              }
            });
            if (show_failed.length) {
              self._biz.reportMessages({
                show_failed: show_failed
              });
            }

          }
          cb(msgs, min_msg_id);
        }, function (error) {
          cb(null);
          fail && fail(error);
        });
      },
      getReplaceMsgRecords: function (opts, cb) {
        var user_id = opts.user_id;
        var user_source = opts.user_source;
        var last_msg_id = opts.last_msg_id;
        var count = opts.count;
        // 撤回消息查询
        var onQueryCompleted = (function () {
          var result = [];
          var count = 0;
          return function (msgs) {
            result = result.concat(msgs);
            if (result.length == 0) {
              return cb(result);
            }
            var param = {
              user_id: user_id,
              user_source: user_source
            }
            var isHasShopId = false;
            if (!isEmpty(opts.shop_id) && !isEmpty(opts.shop_source)) {
              param.shop_id = opts.shop_id;
              param.shop_source = opts.shop_source;
              isHasShopId = true;
            }
            config['getUserinfo']([param], function (contactResult) {
              var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
              var contact = contactResult[userKey];
              if (isHasShopId) {
                contact.shop_id = param.shop_id;
                contact.shop_source = param.shop_source;
                contact.is_shop_mode = true;
              }
              if (contact && isGroupUser(contact)) {
                self._currentcontact = contact;
                var contactKey = self._currentcontact.user_id + '@' + self._currentcontact.user_source;
                if (!isEmpty(self._currentcontact.shop_id) && !isEmpty(self._currentcontact.shop_source)) {
                  contactKey += '@@' + self._currentcontact.shop_id + '@' + self._currentcontact.shop_source;
                }
                if (!isEmpty(self._currentcontact.group_info)) {
                  _groupCurrentCount[contactKey] = self._currentcontact.group_info.current_count;
                }
                var ct = self._children[contactKey];
                !!ct && ct.setContact(self._currentcontact);
              }
            });
            // if (++count === 2) {
            result.sort(function (a, b) {
              return strToNumCompare(a.msg_id, b.msg_id) < 0 ? -1 : 1;
            });
            cb(result);
            //}
          };
        })();

        // 查询比last_msg_id大的count条
        _getReplaceMsgRecords.call(self, {
          user_id: user_id,
          user_source: user_source,
          shop_id: opts.shop_id,
          shop_source: opts.shop_source,
          msg_id: last_msg_id,
          count: count,
          option: 1
        }, function (msgs) {
          onQueryCompleted(msgs);
        }, function (error) {
          onQueryCompleted([]);
        });
      },
      getDeletedMsgRecords: function (opts, cb) {
        self._biz.getDeletedMsgRecords({
          user_id: opts.user_id,
          user_source: opts.user_source,
          shop_id: opts.shop_id,
          shop_source: opts.shop_source
        }, function (msgs) {
          cb && cb(msgs);
        }, function () {

        })
      },
      contact: contact,
      position: self._position,
      component_type: 'ChatWindow'
    });
    if (isGroupUser(contact)) {
      if (_groupCurrentCount && _groupCurrentCount[key] && _groupCurrentCount[key] > contact.group_info.current_count) {
        contact.group_info.current_count = _groupCurrentCount[key];
      }
    }

    ct.setContact(contact);
    ct.addEventListener('organizstructureInit', function () {
      $('.im-app').append($(groupTemplate));
      new Promise((resolve, reject)=>{
        if(isShopModeUserSource(self._currentcontact.user_source)) {
          self._biz.groupAtContacts(self._currentcontact.user_id, self._currentcontact.user_source, function (contacts, id_sources, count) {
            resolve(contacts);
          });
        } else {
          resolve({});
        }
      }).then((contacts)=>{
        var organizstructure = new OrganizStructure({
          ele: $('.im-organization-list.add-group'),
          isAddGroup: true,
          isCreateGroup: true,
          contact: self._currentcontact,
          unavailableGroup: contacts,
          callback: ()=>{
            ct.refreshChatFloat();
          }
        });
        organizstructure.showTp($('.im-contactwindow-organization.add-group'));
      });
    });
    self._children[key] = ct;
    // 获取用户帖子信息
    var topic = _userTopic[key] ? _userTopic[key].content : null;
    if (topic) {
      if (isShopContact) {
        self.setTopic(contact.user_id, contact.user_source, topic, contact.shop_id, contact.shop_source);
      } else {
        self.setTopic(contact.user_id, contact.user_source, topic)
      }
    }
    self._element.append(ct.getElement());
    if (me.is_anonymous_login) {
      if (!isEmpty(self._biz.options) && !isEmpty(self._biz.options.appid) && typeof config['get-template-msg'] === 'function') {
        config['get-template-msg']({
          appId: self._biz.options.appid
        }, (data) => {
          /*
            '您好，请问这个岗位还在招人吗？',
            '这里是文案，想写啥就写啥…',
            '您好，请问什么时候可以面试？',
            '不好意思，该职位不适合我，暂不考…',
            '您好，这个岗位有什么要求？'
           */
          if (!isEmpty(data) && data.length) {
            ct.setStaticInput(data);
          }
        }, () => {
          ct.setStaticInput([

          ]);
        })
      }
    }
  }

  this._biz.getOnlineStatus([opts], function (res) {
    var isonline = res[contact.user_id + '@' + contact.user_source];
    if (isEmpty(isonline))
      return;
    ct.setOnline(isonline);
  });
  // 聊天窗口创建完成后触发事件
  self.triggerEvent('chatwindowCreated', contact.user_id, contact.user_source);
  return ct;
};
App.prototype._switchChatWindow = function (contact) {
  if (!contact)
    return;
  // 对于通知类消息，不支持屏蔽功能
  var self = this;
  var contactkey = contact.user_id + '@' + contact.user_source;
  if (!isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
    contactkey += '@@' + contact.shop_id + '@' + contact.shop_source;
  }
  if (gdic.get('sysUser') && gdic.get('sysUser').indexOf(contactkey) !== -1) {
    //埋点统计（通知会话点击）
    if (window.WMDA_REPORT) {
      window.WMDA_REPORT('custom', { event_id: '17' })
    }
    self._element.find('.im-cwheader-plugins').addClass('hide');
    config['msg-avatar'] = false;
  } else {
    self._element.find('.im-cwheader-plugins').removeClass('hide');
    config['msg-avatar'] = true;
  }

  if (self._findChatWindow(contact) && this._currentcontact) {
    var _currentContactKey = this._currentcontact.user_id + '@' + this._currentcontact.user_source;
    if (!isEmpty(this._currentcontact.shop_id) && !isEmpty(this._currentcontact.shop_source)) {
      _currentContactKey += '@@' + this._currentcontact.shop_id + '@' + this._currentcontact.shop_source;
    }
    if (contactkey === _currentContactKey) {
      return;
    }
  }


  var self = this;
  var param = {
    user_id: contact.user_id,
    user_source: contact.user_source
  }
  var isHasShopId = false;
  if (!isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
    param.shop_id = contact.shop_id;
    param.shop_source = contact.shop_source;
    isHasShopId = true;
  }
  config['getUserinfo']([param], function (contactResult) {
    var userKey = !isHasShopId ? param.user_id + '@' + param.user_source : param.user_id + '@' + param.user_source + '@@' + param.shop_id + '@' + param.shop_source;
    var contactNew = contactResult[userKey];
    if (isHasShopId) {
      contactNew.shop_id = param.shop_id;
      contactNew.shop_source = param.shop_source;
      contactNew.is_shop_mode = true;
    }
    if (contactNew) {
      self._currentcontact = contactNew;
    }
    var ct = self._getChatWindow(self._currentcontact);
    $.each(self._children, function (key, component) {
      if (component instanceof ChatWindow) {
        if (component !== ct) {
          component.unactive();
        }
        else {
          gdic.set('contact', self._currentcontact);
          component.active();
          self._currentcontact = isEmpty(self._currentcontact) ? contact : self._currentcontact;
          self._setUnreadToZero(self._currentcontact.user_id, self._currentcontact.user_source, self._currentcontact);
        }
      }
    });
    if (self._currentcontact) {
      session.setChecked(self._currentcontact.user_id, self._currentcontact.user_source, self._currentcontact);
      asynstore.setSession(self._currentcontact);
    }
  });
};
App.prototype._setUnreadToZero = function (user_id, user_source, contact) {
  this._biz.read(user_id, user_source, null, contact);
  // session.changeUnread(user_id, user_source, 0);
};
App.prototype._gotoContact = function (contact) {
  var self = this;
  // 会话点击
  var isShowChatWin = config['on-session-item-click'](contact);
  // 是否需要切换聊天页面
  if (!isShowChatWin) {
    //埋点统计（帮帮智能客服点击）
    if (window.WMDA_REPORT) {
      window.WMDA_REPORT('custom', { event_id: '16' })
    }
    return;
  }
  if (contact == self._currentcontact) {
    var ct = self._getChatWindow(contact);
    ct && ct.scrollToBottom();
  } else {
    this._switchChatWindow(contact);
  }
  this._setUnreadToZero(contact.user_id, contact.user_source, contact);
};
// 设置聊天窗口话题
App.prototype.setTopic = function (user_id, user_source, html, shop_id, shop_source) {
  var key = user_id + '@' + user_source;
  if (!isEmpty(shop_id) && !isEmpty(shop_source)) {
    key += '@@' + shop_id + '@' + shop_source;
  }
  // 对于之前设置过隐藏的帖子topic，不再进行topic展示
  if (_userTopic[key] && _userTopic[key].hide && (_userTopic[key].content === null || (_userTopic[key].content !== null && _userTopic[key].content == html))) {
    this._children[key] && this._children[key].setTopic();
    return;
  }
  // 保存用户topic信息
  _userTopic[key] = {
    hide: false,
    content: html
  };
  // 如果正在该用户聊天窗口
  if (this._children[key]) {
    if (html) {
      this._children[key].setTopic(html);
    } else {
      this._children[key].setTopic();
    }
  }
};
// 隐藏聊天窗口(某些业务线不需要帖子相关展示)
App.prototype.hideTopic = function (user_id, user_source) {
  var key = user_id + '@' + user_source;
  _userTopic[key] = {
    hide: true,
    content: null
  };
  this.setTopic(user_id, user_source)
};
// 禁止输入，disabled为true时禁用输入框
App.prototype.disableInput = function (user_id, user_source, disabled) {
  if (!disabled) {
    return false;
  }
  var key = user_id + '@' + user_source;
  this._children[key].disableInput();
};
// 设置联系人标识
App.prototype.setContactIdentification = function (user_id, user_source, html) {
  var key = user_id + "@" + user_source,
    chatwindow = this._children[key];
  if (chatwindow) {
    chatwindow.setContactIdentification(html);
  }
};
// 评价卡片
// @sea http://wiki.58corp.com/index.php?title=/IMSDK接口/set_evaluation(设置评价结果)
App.prototype.setEvaluation = function (params, success, failure) {
  this._biz.setEvaluation(params, success, failure);
};
// 切换是否支持音视频功能
App.prototype.switchAudioVideo = function (boolean) {
  config['is_show_audio_video'] = boolean;
  this._biz.switchAudioVideo(boolean);
  if (_isEmpty(this._currentcontact)) {
    return;
  }
  var ct = this._getChatWindow(this._currentcontact);
  ct && ct.switchAudioVideo(boolean);
};
// toast提示
App.prototype.showToast = function (param) {
  dispatcher.dispatch({
    type: ActionType.TOAST_SHOW,
    data: {
      content: param.text ? param.text : '操作失败',
      interval: param.interval ? param.interval : 3000
    }
  });
}
//清除未读数
App.prototype.clearAllUnreadMsgs = function (params, success, failure) {
  this._biz.clearAllUnreadMsgs(params, success, failure);
};
//删除聊天窗口
App.prototype.removeChatwindow = function (contact) {
  if (!contact)
    return;
  // 对于通知类消息，不支持屏蔽功能
  var self = this;
  var ct = self._getChatWindow(contact);
  if (!isEmpty(ct)) {
    ct.unactive();
    $.each(self._children, function (key, component) {
      if (component instanceof ChatWindow) {
        if (component === ct) {
          component.destroy();
          component = null;
          var key = contact.user_id + '@' + contact.user_source;
          if (isShopModeUser(contact) && !isEmpty(contact.shop_id) && !isEmpty(contact.shop_source)) {
            key += '@@' + contact.shop_id + '@' + contact.shop_source;
          }
          delete self._children[key];
          gdic.set('contact', null);
        }
      }
    });
    // session.setChecked(self._currentcontact.user_id, self._currentcontact.user_source, self._currentcontact);
    // asynstore.setSession(self._currentcontact);
  }
};

//webRtc事件绑定
bindRtcEvents(App);

module.exports = App;
